import React from 'react';
import { IMapLessonItemStates } from 'types';
import Checkmarks from 'components/common/maps/checkmarks';

const Science: React.FC<IMapLessonItemStates> = ({
  active,
  visited,
  process,
}: IMapLessonItemStates) => {
  return (
    <g
      className={
        active
          ? 'prefix__component-item animationComponent'
          : 'prefix__component-item'
      }
    >
      {active && (
        <g
          className={
            active
              ? 'prefix__active-process animation'
              : 'prefix__active-process'
          }
        >
          <image
            width={242}
            height={318}
            xlinkHref="data:image/png;base64,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"
          />
        </g>
      )}
      <g id="e7e635f6-3bab-4ac9-bd82-741d3dd7a389" data-name="science">
        <g>
          <g>
            <path
              d="M103.69,239.64c-7.17,4.15-7.17,11,0,15.1l32,18.45c7.18,4.15,18.94,4.15,26.12,0l32-18.45c7.19-4.15,7.19-10.93,0-15.08l-32.08-18.52c-7.18-4.15-18.93-4.14-26.1,0Z"
              fill="#b96a79"
            />
            <path
              d="M199,239.8s1.16,9.48-1.42,11.78c-4.16,3.72-37,24.72-46.53,24.58-.84,0-2.31.14-2.31.14v-8.73Z"
              fill="#995b6a"
            />
            <polygon
              points="98.27 239.8 98.27 247.16 148.73 273.33 148.72 267.57 98.27 239.8"
              fill="#b96a79"
            />
            <path
              d="M103.69,232.23c-7.17,4.16-7.17,11,0,15.11l32,18.45c7.18,4.15,18.94,4.15,26.12,0l32-18.45c7.19-4.15,7.19-10.94,0-15.08l-32.08-18.52c-7.18-4.15-18.93-4.14-26.1,0Z"
              fill="#3d356f"
            />
            <path
              d="M103.69,232.23c-7.17,4.16-7.17,11,0,15.11l32,18.45c7.18,4.15,18.94,4.15,26.12,0l32-18.45c7.19-4.15,7.19-10.94,0-15.08l-32.08-18.52c-7.18-4.15-18.93-4.14-26.1,0Z"
              fill="#3d356f"
            />
          </g>
          <path
            d="M106,240s11.18,10.07,20.13,10.07S144.71,252,148,252s34,2,34,2,13.32-6.27,16-10c3.32-4.62-.13-12.33-16-18-.33-.12-34.62,8.68-44.18,7.21S106,240,106,240Z"
            fill="#141c66"
            opacity="0.72"
          />
          <path
            d="M117.48,170.34V172l-2.73-.44-.54-.09h0l-3.73-.62c-6.25-1-15.7-2.58-24.07-4l-5.84-1c-7-1.21-12.24-2.17-12.33-2.34s.83-.45,2.07-.67a30.77,30.77,0,0,1,5.26-.49c.37,0,3.32.58,7.51,1.37l6.33,1.21h0c10.76,2.06,24.33,4.69,27.43,5.29Z"
            fill="#a05f7e"
          />
          <path
            d="M144,232.29a23.69,23.69,0,0,1-2.81-9V118.09c0-11.08.72-15.73,1.69-17.48l.26,31,.08,9.06Z"
            fill="#591b9b"
          />
          <path
            d="M58.83,66.55l63.7-9.1v1.68L58,72.29S56.63,70.1,58.83,66.55Z"
            fill="#a05f7e"
          />
          <path
            d="M118.32,122.86l-.12,1.29-1.86.59-21,6.67L84.13,135,75,137.9l-.13,0s-1,.07-3.37-2.64l0,0-.14-.17,0-.05c-.08-.08-.15-.18-.24-.27l9.35-2.36,11-2.78,21.81-5.49,3.75-1h0l.35-.09h0l.22-.06Z"
            fill="#a05f7e"
          />
          <path
            d="M75.08,52.93s3.36-1.42,3.72-1.42,43.43,6.2,43.43,6.2l.07,1.74Z"
            fill="#b97a95"
          />
          <polygon
            points="112.68 57.06 111.7 57.98 114.48 58.35 116.09 57.56 112.68 57.06"
            fill="#716f81"
            opacity="0.46"
          />
          <path
            d="M119.34,185.63,114,202.34V243c-1,.15-5-1-7.39-3.18V199.18l7.33,3.09Z"
            fill="#efa17b"
          />
          <polygon
            points="128.11 33 123.73 40.42 123.73 74.61 119.47 85.51 119.34 185.63 117.42 185.5 117.42 84.48 122.47 74.03 122.11 39.97 128.11 33"
            fill="#b97a95"
          />
          <polygon
            points="117.42 185.63 119.34 185.76 113.94 202.4 106.61 199.3 117.42 185.63"
            fill="#f6ae99"
          />
          <polygon
            points="117.42 176.16 119.36 174.77 119.36 173.7 118.44 173.5 117.42 174.08 117.42 176.16"
            fill="#716f81"
            opacity="0.54"
          />
          <polygon
            points="117.42 185.63 119.34 185.76 113.94 202.4 106.61 199.3 117.42 185.63"
            fill="#f6ae99"
          />
          <path
            d="M119.4,172.66V174L99.3,188.43h0l-5.88,4.24-.33.24h0l-1.18.85s-9,.24-10.8.21l.86-.48.14-.07,5.52-3.08,6-3.32Z"
            fill="#a05f7e"
          />
          <polygon
            points="119.41 132.79 117.48 135.25 117.42 137.04 119.44 134.99 119.41 132.79"
            fill="#716f81"
            opacity="0.26"
          />
          <path
            d="M117.66,190.81l-4.68.44-6.37,8.05.66.28,1,.3a17.67,17.67,0,0,0,7.51-3.22Z"
            fill="#716f81"
            opacity="0.54"
          />
          <polygon
            points="119.41 142.09 117.48 144.15 117.48 148.02 119.44 144.92 119.41 142.09"
            fill="#716f81"
            opacity="0.26"
          />
          <path
            d="M128.11,33V239.82S125,244,114,243V203.34l5.34-17.71.12-100.12,4.27-10.9V40.42Z"
            fill="#a05f7e"
          />
          <polygon
            points="119.89 172.66 119.89 174.34 120.84 176.21 121.06 173.45 119.89 172.66"
            fill="#b97a95"
          />
          <path
            d="M119.89,172.66h-.53v3.55s1.85,2.56,0,4.8l-1.86,2.23-.12,1.81s5.41-5.16,4.57-7.36S119.89,172.66,119.89,172.66Z"
            fill="#716f81"
            opacity="0.26"
          />
          <path
            d="M128.11,187.37V172.05a9.47,9.47,0,0,0-.78-.94c-1.63,1.29-4,3-5.64,4.32a8,8,0,0,1,1.44,4.46c0,2.74-1.59,5.33-4.38,7.6l-3,9.22C121.38,194.19,125.67,191,128.11,187.37Z"
            fill="#716f81"
            opacity="0.26"
          />
          <path
            d="M125.53,170.06c-1.63,1.28-4,3-5.64,4.31a8,8,0,0,1,1.44,4.45c0,9-16.92,16.24-37.78,16.24s-37.78-7.27-37.78-16.24,16.91-16.23,37.78-16.23c14,0,27.42,3.36,33.93,8.25a58.63,58.63,0,0,1-.07-6.07c-8.25-4.61-20.36-7.53-33.86-7.53-24.88,0-45,9.9-45,22.1s20.17,22.09,45.05,22.09,45-9.89,45-22.09C128.59,176.07,128.12,172.85,125.53,170.06Z"
            fill="#a05f7e"
          />
          <path
            d="M124.81,121.18c-.46.54-2.31,2.16-2.88,2.84.6,1-.39,1.22-.12,2.2a6.4,6.4,0,0,1-2.41,6.58v5.86c4.71-3.83,7.47-8.32,7.32-12.27A6.77,6.77,0,0,0,124.81,121.18Z"
            fill="#716f81"
            opacity="0.26"
          />
          <polygon
            points="121.87 124.09 121.87 126.28 122.89 128.41 122.83 124.09 121.87 124.09"
            fill="#b97a95"
          />
          <path
            d="M128.11,127.39a13.54,13.54,0,0,0-1.92-3c-.46.53-2.86,2.61-3.44,3.3a6.45,6.45,0,0,1,1,3.07c.09,2.42-1.51,5.12-4.34,7.59v6.54c4.23-2.88,7.3-6.31,8.72-9.66Z"
            fill="#716f81"
            opacity="0.26"
          />
          <polygon
            points="124.81 52.42 124.81 55 129.62 55.64 129.62 53.58 124.81 52.42"
            fill="#b97a95"
          />
          <path
            d="M128.16,129.48a11,11,0,0,0-2.81-6.51c-.47.53-2.86,2.61-3.44,3.3a6.48,6.48,0,0,1,1,3.07c.25,6.48-11.69,15-26.75,15.65s-27.53-6.78-27.78-13.26,11.69-15.28,26.76-15.3c11.66,0,22.35,5.53,22.35,5.53v-5s-12-4.57-22.57-4.6c-18.63,0-32.1,11.18-31.77,20s15.27,19.09,33.23,18.31S128.49,138.3,128.16,129.48Z"
            fill="#b97a95"
          />
          <polygon
            points="121.87 124.09 121.87 126.28 122.89 128.41 122.83 124.09 121.87 124.09"
            fill="#716f81"
            opacity="0.46"
          />
          <path
            d="M68.37,131.56c0-3.88,4.26-8.56,10.92-11.68h0s-.25-.89,1.15-2.52l-2.24-1-7.93,5.68s-2.76,9.29-2.64,9.42A2.55,2.55,0,0,0,68.37,131.56Z"
            fill="#716f81"
            opacity="0.46"
          />
          <path
            d="M128.6,177.69a12,12,0,0,1-1.63,5.92c-2.31,4.08-6.93,7.69-13.13,10.47-8,3.57-18.63,5.74-30.3,5.74-24.87,0-45-9.91-45-22.13s20.17-22.13,45-22.13A88.15,88.15,0,0,1,99.35,157a66.72,66.72,0,0,1,13.21,3.81,45.71,45.71,0,0,1,4.86,2.34s-.11,3.14,0,5.2a1.48,1.48,0,0,0,0,.21c0,.24,0,.46,0,.66-4.41-3.31-12-5.93-20.78-7.27a86.86,86.86,0,0,0-9.35-.91h0c-1.25-.05-2.52-.08-3.79-.08q-3.87,0-7.52.33h0a75.65,75.65,0,0,0-7.78,1.07c-10.66,2-18.71,6.13-21.45,11.1a7.8,7.8,0,0,0-1,3.76.57.57,0,0,0,0,.13,7.23,7.23,0,0,0,.71,3v0a9.85,9.85,0,0,0,1.12,1.84c.1.14.21.27.32.4v0c.21.25.43.5.66.74,5.3,5.53,17.47,9.53,31.93,10h.07l1.49,0h1.45c1.31,0,2.6,0,3.87-.08h.19l.63,0,.3,0,.56,0,1.34-.09.3,0,.33,0,2-.2h0l.81-.1a61.47,61.47,0,0,0,15.81-3.9h0c7.16-3,11.62-7.12,11.62-11.73a8,8,0,0,0-1.44-4.46c1.63-1.33,4-3,5.64-4.32C128.13,171.19,128.6,174.42,128.6,177.69Z"
            fill="#efa17b"
          />
          <path
            d="M45.65,177.44A8.37,8.37,0,0,1,46,175a10.06,10.06,0,0,1,1.1-2.26A15.39,15.39,0,0,1,50.52,169a34,34,0,0,1,8.87-4.7,56,56,0,0,1,9.69-2.57,79.38,79.38,0,0,1,10-1.16A84.93,84.93,0,0,1,99,162a66.71,66.71,0,0,1,9.63,2.68,32,32,0,0,1,8.76,4.73,32.13,32.13,0,0,0-4.34-2.38,43,43,0,0,0-4.64-1.71,64.43,64.43,0,0,0-9.6-2.28A90.72,90.72,0,0,0,79.1,162a72.15,72.15,0,0,0-19.36,3.36,33.86,33.86,0,0,0-8.82,4.24,15.23,15.23,0,0,0-3.56,3.33A8.35,8.35,0,0,0,45.65,177.44Z"
            fill="#545370"
          />
          <g>
            <path
              d="M128.11,92.77a60.25,60.25,0,0,1-8.66,3.08v9a67.73,67.73,0,0,0,8.67-2.85Z"
              fill="#716f81"
              opacity="0.26"
            />
            <path
              d="M123.73,50v6.75l.24.08c.12-.94.08-5.35.1-6.73Z"
              fill="#716f81"
              opacity="0.26"
            />
            <path
              d="M126.61,57.84c.51.21,1,.42,1.5.64V55.29C127.61,56.16,127.11,57,126.61,57.84Z"
              fill="#716f81"
              opacity="0.26"
            />
          </g>
          <path
            d="M128.17,49.19c-1.08,1.91-2.24,4-3.36,5.81,10.73,4.45,18.37,11.47,18.37,17.6,0,10.17-19.2,22.69-42.83,22.69S57.61,82.77,57.61,72.6s19.11-22.24,42.74-22.24A63.32,63.32,0,0,1,122.29,54c.12-.95-.05-5.36,0-6.74A76,76,0,0,0,100.35,44c-28.18,0-51,15.32-51,29.16s22.79,31,51,31,51.06-17.12,51.06-31C151.41,64.5,141.85,54.89,128.17,49.19Z"
            fill="#a05f7e"
          />
          <path
            d="M128.16,127.29c.1,2.7-1.15,5.65-3.46,8.47a33.42,33.42,0,0,1-11.9,8.75,44.39,44.39,0,0,1-16.43,3.94c-18,.78-32.89-9.5-33.23-18.31-.14-3.7,2.15-7.83,6.24-11.37A32.15,32.15,0,0,1,76.76,114a42.27,42.27,0,0,1,18.16-3.9c10.58,0,22.56,4.59,22.56,4.59v5s-10.69-5.55-22.34-5.54a37.81,37.81,0,0,0-16.74,3.89h0l-.27.14a29.57,29.57,0,0,0-4,2.47,20.62,20.62,0,0,0-2.66,2.33c-2.06,2.15-3.19,4.43-3.12,6.47a7.58,7.58,0,0,0,1.84,4.33c.24.29.47.55.69.8l.39.38,0,.05a18.79,18.79,0,0,0,2,1.71l0,0c.5.37,1,.72,1.62,1.08,5.12,3.1,12.73,5.27,21.14,4.9a41.5,41.5,0,0,0,4.8-.48c1-.16,2-.35,2.89-.56,1.34-.31,2.63-.67,3.88-1.09a34,34,0,0,0,9.35-4.75c3.74-2.77,5.94-6,5.83-8.77a6.48,6.48,0,0,0-1-3.07c.58-.69,3-2.77,3.44-3.3A11,11,0,0,1,128.16,127.29Z"
            fill="#efa17b"
          />
          <path
            d="M63.25,130.92A10.38,10.38,0,0,0,65,135.65a18,18,0,0,0,3.37,3.75A31.53,31.53,0,0,0,77,144.57a46.75,46.75,0,0,0,19.77,3.34A42.93,42.93,0,0,0,116,142.42a31.85,31.85,0,0,0,7.88-6.2,18.34,18.34,0,0,0,2.83-4.11,14,14,0,0,0,.9-2.33,9.72,9.72,0,0,0,.33-2.46l.44,0a11,11,0,0,1-1,5.11,18.76,18.76,0,0,1-2.8,4.38,30.75,30.75,0,0,1-8,6.65,42.73,42.73,0,0,1-19.75,5.8,48.29,48.29,0,0,1-10.33-.73,41.17,41.17,0,0,1-9.89-3,31.19,31.19,0,0,1-8.66-5.63,18.27,18.27,0,0,1-3.24-4,12.1,12.1,0,0,1-1-2.36A9.54,9.54,0,0,1,63.25,130.92Z"
            fill="#545370"
          />
          <path
            d="M68.49,129a6.88,6.88,0,0,1,.7-3.47,13.94,13.94,0,0,1,2-3A24.29,24.29,0,0,1,76.71,118a34.91,34.91,0,0,1,13.52-4.62,38.28,38.28,0,0,1,7.18-.24,40.16,40.16,0,0,1,7.07,1.19,47.5,47.5,0,0,1,13.06,5.51,58.38,58.38,0,0,0-6.55-2.61,51.58,51.58,0,0,0-6.75-1.87,40.25,40.25,0,0,0-13.83-.63,37.84,37.84,0,0,0-13.18,4.18A23.87,23.87,0,0,0,71.65,123,9.53,9.53,0,0,0,68.49,129Z"
            fill="#545370"
          />
          <ellipse
            cx="78.19"
            cy="117.88"
            rx="1.07"
            ry="0.19"
            transform="translate(-46.03 50.21) rotate(-27.87)"
            fill="#ffea38"
          />
          <path
            d="M124.81,57.45v-.78l12.94,23.45s-2.17,2-3,2.69Z"
            fill="#b97a95"
          />
          <path
            d="M124.81,57.45v-.78l12.94,23.45s-2.17,2-3,2.69Z"
            fill="#716f81"
            opacity="0.26"
          />
          <path
            d="M128.17,46.61c-1.08,1.91-2.24,4-3.36,5.81,10.73,4.45,18.37,11.47,18.37,17.6,0,10.17-19.2,22.69-42.83,22.69S57.61,80.19,57.61,70s19.11-22.24,42.74-22.24a62.63,62.63,0,0,1,21.82,3.61c.11-1,.07-5.36.1-6.74a76,76,0,0,0-21.92-3.2c-28.18,0-51,15.32-51,29.16s22.79,31,51,31,51.06-17.12,51.06-31C151.41,61.92,141.85,52.31,128.17,46.61Z"
            fill="#ffceb1"
          />
          <path
            d="M128.17,46.61c-1.08,1.91-2.24,4-3.36,5.81,10.73,4.45,18.37,11.47,18.37,17.6,0,10.17-19.2,22.69-42.83,22.69S57.61,80.19,57.61,70s19.11-22.24,42.74-22.24a62.63,62.63,0,0,1,21.82,3.61c.11-1,.07-5.36.1-6.74a76,76,0,0,0-21.92-3.2c-28.18,0-51,15.32-51,29.16s22.79,31,51,31,51.06-17.12,51.06-31C151.41,61.92,141.85,52.31,128.17,46.61Z"
            fill="#efa17b"
          />
          <path
            d="M122.23,51.45a100.52,100.52,0,0,0-18-3.27,58.36,58.36,0,0,0-9.16,0,66.1,66.1,0,0,0-9.08,1.26,56.92,56.92,0,0,0-17.12,6.44,31.6,31.6,0,0,0-7.21,5.64c-2,2.23-3.8,5-3.88,8.12,0-3.13,1.63-6,3.64-8.33a32,32,0,0,1,7.14-5.93A56,56,0,0,1,85.73,48.5a69.87,69.87,0,0,1,18.53-1.65,47.13,47.13,0,0,1,9.23,1.41c1.5.41,3,.88,4.45,1.39S120.83,50.77,122.23,51.45Z"
            fill="#716f81"
          />
          <path
            d="M125.11,52.48A31.35,31.35,0,0,1,137,58.85,22.07,22.07,0,0,1,141.41,64a10.73,10.73,0,0,1,1.72,6.52,13.36,13.36,0,0,0-2.61-5.93,29.35,29.35,0,0,0-4.46-4.73,47.38,47.38,0,0,0-5.25-4C129,54.73,127.06,53.59,125.11,52.48Z"
            fill="#716f81"
          />
          <path
            d="M49.38,70.61a15.51,15.51,0,0,0,.69,3.94,19.9,19.9,0,0,0,1.6,3.66,29,29,0,0,0,4.88,6.31,49.22,49.22,0,0,0,13,9.19,68.5,68.5,0,0,0,30.84,7.18,68.82,68.82,0,0,0,30.85-7.2,49.79,49.79,0,0,0,13-9.18,29,29,0,0,0,4.88-6.3,20.24,20.24,0,0,0,1.61-3.66,15.51,15.51,0,0,0,.69-3.94,15.93,15.93,0,0,1-.49,4,20.39,20.39,0,0,1-1.49,3.77A29.49,29.49,0,0,1,144.71,85a50.29,50.29,0,0,1-13,9.66,64,64,0,0,1-15.2,5.67,70.63,70.63,0,0,1-16.13,2,71.15,71.15,0,0,1-16.12-1.94,63.44,63.44,0,0,1-15.2-5.68,49.46,49.46,0,0,1-13-9.66,29.55,29.55,0,0,1-4.72-6.6,20.36,20.36,0,0,1-1.48-3.77A15.49,15.49,0,0,1,49.38,70.61Z"
            fill="#545370"
          />
          <path
            d="M190.16,244.4c-9.64,1.81-27.39-1.92-38.09-4.58a11.82,11.82,0,0,1-8.11-7.53,12.79,12.79,0,0,1-.8-4.47l-.32-87,0-9.07-.11-30.13a2.37,2.37,0,0,1,.13-1c.56-1.36,3,.41,8.58,7.35,2.2,2.76,4,8.59,5.49,15.28.65,2.94,1.22,6,1.73,9.12,1.75,10.6,2.69,21,2.87,23.47.32,4.29,1.46,51.61,1.74,63.23a7.46,7.46,0,0,0,1.63,4.5l2.52,3.1c4.08,5,18,7.86,22.7,12.12S190.16,244.4,190.16,244.4Z"
            fill="#545370"
          />
          <path
            d="M157.36,232.27c-1.17-4.42-.91-82-.77-110.48-1.41-6.07-3.13-11.27-5.17-13.83-6.49-8.13-8.77-9.16-8.71-6.39l.45,126.25a12.2,12.2,0,0,0,8.91,12c7.33,1.83,18,4.15,27,4.85C169.42,241.21,158.27,235.69,157.36,232.27Z"
            fill="#efa17b"
          />
          <path
            d="M157.36,232.27c-1.17-4.42-.91-82-.77-110.48-1.41-6.07-3.13-11.27-5.17-13.83-6.49-8.13-8.77-9.16-8.71-6.39l.45,126.25a12.2,12.2,0,0,0,8.91,12c7.33,1.83,18,4.15,27,4.85C169.42,241.21,158.27,235.69,157.36,232.27Z"
            fill="#716f81"
            opacity="0.46"
          />
          <ellipse cx="152.56" cy="191.95" rx="1.8" ry="6" fill="#7163c1" />
          <path
            d="M154.36,191.82a12.39,12.39,0,0,0-.93-5.26h0s.84,10-2.06,9.77h0c.32.93.73,1.49,1.19,1.49C153.55,197.82,154.36,195.13,154.36,191.82Z"
            fill="#af5d4e"
            opacity="0.89"
          />
          <path
            d="M154.22,189.07l-3.46,2.3,0,1.06Z"
            fill="#edf4f9"
            opacity="0.71"
          />
          <path
            d="M147.37,103.21h0L145,101c-1.66-1.28-2.32-.9-2.29.61l.45,126.25a12.7,12.7,0,0,0,4.21,9.51Z"
            fill="#efa17b"
          />
          <path
            d="M152.56,186a.93.93,0,0,1,.69.41,3.23,3.23,0,0,1,.42.72,8,8,0,0,1,.49,1.58,16.57,16.57,0,0,1,0,6.58,8,8,0,0,1-.49,1.58,3.23,3.23,0,0,1-.42.72.93.93,0,0,1-.69.41.88.88,0,0,0,.64-.45,3.23,3.23,0,0,0,.36-.72,8.53,8.53,0,0,0,.41-1.58,18.6,18.6,0,0,0,.27-3.25,19.61,19.61,0,0,0-.26-3.25,9.43,9.43,0,0,0-.42-1.58,3.23,3.23,0,0,0-.36-.72A.88.88,0,0,0,152.56,186Z"
            fill="#ff7314"
          />
          <path
            d="M146.49,212.1s23.07,10,32.8,4.11c0,0-.24-1.81-3.61-3.36s-29.55-24.38-30.75-35.22Z"
            fill="#efa17b"
          />
          <path
            d="M176.41,217.43h0c-30.68-2.06-25.77-28.78-25.77-28.78h0l-4.81-5.54-.29,29.95S165.43,220.58,176.41,217.43Z"
            fill="#af5d4e"
            opacity="0.89"
          />
          <ellipse cx="142.68" cy="199.88" rx="3.51" ry="0.97" fill="#ff7314" />
          <path
            d="M149.62,185.88c0-5.93-1.53-11.07-3.76-13.58-.93-1.05-5.2-1.05-6.09-.1-2.31,2.45-3.85,7.62-3.85,13.68,0,5.88,1.5,11,3.69,13.51.94,1.09,5.31,1.13,6.23.1C148.08,197,149.62,191.83,149.62,185.88Z"
            fill="#d88850"
          />
          <polygon
            points="122.47 74.03 123.67 74.54 119.47 85.51 117.42 84.48 122.47 74.03"
            fill="#efa17b"
          />
          <polygon
            points="122.11 39.97 123.67 40.35 127.64 33.55 122.11 39.97"
            fill="#f6ae99"
          />
          <polygon
            points="121.33 150.08 121.33 152.66 127.09 146.99 127.09 144.41 121.33 150.08"
            fill="#545370"
          />
          <polygon
            points="121.57 151.16 121.57 151.76 123.01 150.43 123.01 149.83 121.57 151.16"
            fill="#ffea38"
          />
          <polygon
            points="123.49 148.32 123.49 148.92 124.93 147.59 124.93 146.99 123.49 148.32"
            fill="#ffea38"
          />
          <polygon
            points="123.61 108.71 123.61 110.43 127.45 106.65 127.45 104.93 123.61 108.71"
            fill="#545370"
          />
          <polygon
            points="123.49 112.45 123.49 114.17 127.33 110.39 127.33 108.67 123.49 112.45"
            fill="#545370"
          />
          <polygon
            points="124.81 59.07 124.81 60.16 127.24 57.76 127.24 56.67 124.81 59.07"
            fill="#b97a95"
          />
          <polygon
            points="124.81 60.88 124.81 61.97 127.24 59.57 127.24 58.48 124.81 60.88"
            fill="#b97a95"
          />
          <polygon
            points="123.49 115.94 123.49 117.66 127.33 113.87 127.33 112.15 123.49 115.94"
            fill="#545370"
          />
          <polygon
            points="121.33 155.37 121.33 157.95 127.09 152.28 127.09 149.7 121.33 155.37"
            fill="#545370"
          />
          <polygon
            points="121.33 160.92 121.33 163.5 127.09 157.82 127.09 155.24 121.33 160.92"
            fill="#545370"
          />
          <polygon
            points="116.28 206.96 116.28 211.37 126.13 201.67 126.13 197.26 116.28 206.96"
            fill="#545370"
          />
          <polygon
            points="116.16 215.86 116.16 220.27 126.01 210.57 126.01 206.16 116.16 215.86"
            fill="#545370"
          />
          <polygon
            points="75.08 51.9 75.08 53.06 76.88 53.06 76.64 51.9 75.08 51.9"
            fill="#b97a95"
          />
          <ellipse
            cx="94.24"
            cy="101.31"
            rx="0.19"
            ry="1.44"
            transform="translate(-16.76 183.93) rotate(-83.73)"
            fill="#ffea38"
          />
          <ellipse
            cx="90.03"
            cy="100.8"
            rx="0.19"
            ry="1.44"
            transform="translate(-19.99 179.29) rotate(-83.73)"
            fill="#ffea38"
          />
          <ellipse
            cx="85.47"
            cy="100.02"
            rx="0.19"
            ry="1.45"
            transform="translate(-31.27 160.7) rotate(-76.95)"
            fill="#ffea38"
          />
          <ellipse
            cx="81.51"
            cy="98.86"
            rx="0.19"
            ry="1.45"
            transform="translate(-36.22 149.44) rotate(-73.75)"
            fill="#ffea38"
          />
          <ellipse
            cx="77.42"
            cy="97.57"
            rx="0.19"
            ry="1.45"
            transform="translate(-41.21 135.54) rotate(-69.32)"
            fill="#ffea38"
          />
          <ellipse
            cx="73.7"
            cy="96.15"
            rx="0.19"
            ry="1.45"
            transform="translate(-42.29 131.14) rotate(-69.32)"
            fill="#ffea38"
          />
          <ellipse
            cx="69.61"
            cy="94.35"
            rx="0.19"
            ry="1.46"
            transform="translate(-45.9 114.45) rotate(-63.45)"
            fill="#ffea38"
          />
          <ellipse
            cx="66.01"
            cy="92.28"
            rx="0.19"
            ry="1.46"
            transform="translate(-46.05 110.09) rotate(-63.45)"
            fill="#ffea38"
          />
          <ellipse
            cx="63.04"
            cy="90.38"
            rx="0.19"
            ry="0.99"
            transform="translate(-47.1 87.04) rotate(-53.37)"
            fill="#ffea38"
          />
          <ellipse
            cx="60.88"
            cy="88.83"
            rx="0.19"
            ry="0.99"
            transform="translate(-46.73 84.68) rotate(-53.37)"
            fill="#ffea38"
          />
          <ellipse
            cx="58.89"
            cy="87.15"
            rx="0.19"
            ry="0.76"
            transform="translate(-45.01 70.76) rotate(-46.99)"
            fill="#ffea38"
          />
          <ellipse
            cx="57.21"
            cy="85.6"
            rx="0.19"
            ry="0.76"
            transform="translate(-44.41 69.04) rotate(-46.99)"
            fill="#ffea38"
          />
          <ellipse
            cx="55.78"
            cy="84.18"
            rx="0.14"
            ry="0.57"
            transform="translate(-42.3 60.13) rotate(-42.69)"
            fill="#ffea38"
          />
          <ellipse
            cx="54.58"
            cy="82.89"
            rx="0.14"
            ry="0.57"
            transform="translate(-41.74 58.98) rotate(-42.69)"
            fill="#ffea38"
          />
          <ellipse
            cx="53.75"
            cy="81.89"
            rx="0.09"
            ry="0.37"
            transform="translate(-39.1 50.68) rotate(-38.14)"
            fill="#ffea38"
          />
          <ellipse
            cx="52.91"
            cy="80.6"
            rx="0.09"
            ry="0.37"
            transform="translate(-38.48 49.89) rotate(-38.14)"
            fill="#ffea38"
          />
          <ellipse
            cx="52.19"
            cy="79.44"
            rx="0.09"
            ry="0.37"
            transform="matrix(0.79, -0.62, 0.62, 0.79, -37.92, 49.19)"
            fill="#ffea38"
          />
          <ellipse cx="98.98" cy="101.64" rx="1.44" ry="0.19" fill="#ffea38" />
          <ellipse
            cx="92.98"
            cy="113.77"
            rx="1.44"
            ry="0.19"
            transform="matrix(1, -0.07, 0.07, 1, -7.87, 6.92)"
            fill="#ffea38"
          />
          <ellipse cx="95.02" cy="148.6" rx="1.44" ry="0.19" fill="#ffea38" />
          <ellipse
            cx="90.21"
            cy="148.47"
            rx="0.19"
            ry="1.44"
            transform="translate(-66.14 224.2) rotate(-84.56)"
            fill="#ffea38"
          />
          <ellipse cx="81.45" cy="161.24" rx="1.44" ry="0.19" fill="#ffea38" />
          <ellipse
            cx="77.12"
            cy="161.37"
            rx="1.44"
            ry="0.19"
            transform="translate(-11.86 6.23) rotate(-4.29)"
            fill="#ffea38"
          />
          <ellipse
            cx="73.1"
            cy="161.82"
            rx="1.15"
            ry="0.15"
            transform="translate(-11.91 5.93) rotate(-4.29)"
            fill="#ffea38"
          />
          <ellipse
            cx="69.86"
            cy="162.34"
            rx="1.15"
            ry="0.15"
            transform="translate(-24.77 13.08) rotate(-9.09)"
            fill="#ffea38"
          />
          <ellipse
            cx="66.98"
            cy="162.85"
            rx="1.15"
            ry="0.15"
            transform="translate(-24.89 12.63) rotate(-9.09)"
            fill="#ffea38"
          />
          <ellipse
            cx="64.29"
            cy="163.49"
            rx="0.73"
            ry="0.1"
            transform="translate(-35.31 18.77) rotate(-13.07)"
            fill="#ffea38"
          />
          <ellipse
            cx="58.76"
            cy="165.17"
            rx="0.73"
            ry="0.1"
            transform="translate(-54.14 31.05) rotate(-20.51)"
            fill="#ffea38"
          />
          <ellipse
            cx="56.36"
            cy="166.07"
            rx="0.73"
            ry="0.1"
            transform="translate(-54.6 30.27) rotate(-20.51)"
            fill="#ffea38"
          />
          <ellipse
            cx="54.2"
            cy="167.23"
            rx="0.73"
            ry="0.1"
            transform="translate(-66.33 39.26) rotate(-25.33)"
            fill="#ffea38"
          />
          <ellipse
            cx="61.64"
            cy="164.14"
            rx="0.73"
            ry="0.1"
            transform="translate(-44.17 24.34) rotate(-16.54)"
            fill="#ffea38"
          />
          <ellipse cx="85.29" cy="161.24" rx="1.44" ry="0.19" fill="#ffea38" />
          <ellipse
            cx="88.77"
            cy="161.44"
            rx="0.13"
            ry="0.96"
            transform="matrix(0.06, -1, 1, 0.06, -78.05, 239.62)"
            fill="#ffea38"
          />
          <ellipse
            cx="91.54"
            cy="161.57"
            rx="0.13"
            ry="0.96"
            transform="translate(-75.6 242.5) rotate(-86.3)"
            fill="#ffea38"
          />
          <ellipse
            cx="94.54"
            cy="161.82"
            rx="0.13"
            ry="0.96"
            transform="translate(-73.04 245.73) rotate(-86.3)"
            fill="#ffea38"
          />
          <ellipse
            cx="97.42"
            cy="162.34"
            rx="0.13"
            ry="0.96"
            transform="translate(-77.56 234.64) rotate(-81.48)"
            fill="#ffea38"
          />
          <ellipse
            cx="100.67"
            cy="162.86"
            rx="0.13"
            ry="0.96"
            transform="translate(-75.31 238.29) rotate(-81.48)"
            fill="#ffea38"
          />
          <ellipse
            cx="103.12"
            cy="163.37"
            rx="0.1"
            ry="0.78"
            transform="translate(-79.61 226.09) rotate(-76.68)"
            fill="#ffea38"
          />
          <ellipse
            cx="105.65"
            cy="164.14"
            rx="0.1"
            ry="0.78"
            transform="translate(-78.42 229.14) rotate(-76.68)"
            fill="#ffea38"
          />
          <ellipse
            cx="86.18"
            cy="147.81"
            rx="0.15"
            ry="1.13"
            transform="translate(-74.16 207.55) rotate(-80.19)"
            fill="#ffea38"
          />
          <ellipse
            cx="82.57"
            cy="147.04"
            rx="0.15"
            ry="1.14"
            transform="translate(-80.09 191.53) rotate(-75.98)"
            fill="#ffea38"
          />
          <ellipse
            cx="79.01"
            cy="146"
            rx="0.21"
            ry="0.9"
            transform="translate(-85.08 171.13) rotate(-70.29)"
            fill="#ffea38"
          />
          <ellipse
            cx="76.12"
            cy="144.84"
            rx="0.21"
            ry="0.9"
            transform="translate(-86.68 161.2) rotate(-68.01)"
            fill="#ffea38"
          />
          <ellipse
            cx="73.48"
            cy="143.42"
            rx="0.21"
            ry="0.91"
            transform="translate(-87.65 141.11) rotate(-62.05)"
            fill="#ffea38"
          />
          <ellipse
            cx="71.09"
            cy="141.94"
            rx="0.16"
            ry="0.68"
            transform="translate(-86.95 127.01) rotate(-58)"
            fill="#ffea38"
          />
          <ellipse
            cx="69.46"
            cy="140.78"
            rx="0.15"
            ry="0.46"
            transform="translate(-84.64 110.86) rotate(-52.75)"
            fill="#ffea38"
          />
          <ellipse
            cx="68.14"
            cy="139.61"
            rx="0.15"
            ry="0.46"
            transform="translate(-84.24 109.35) rotate(-52.75)"
            fill="#ffea38"
          />
          <ellipse
            cx="66.94"
            cy="138.45"
            rx="0.15"
            ry="0.46"
            transform="translate(-78.82 89.42) rotate(-45.6)"
            fill="#ffea38"
          />
          <ellipse
            cx="99.22"
            cy="148.21"
            rx="1.44"
            ry="0.19"
            transform="translate(-13.97 10.37) rotate(-5.59)"
            fill="#ffea38"
          />
          <ellipse
            cx="103.67"
            cy="147.83"
            rx="1.45"
            ry="0.19"
            transform="translate(-30.37 26.86) rotate(-12.89)"
            fill="#ffea38"
          />
          <ellipse
            cx="107.99"
            cy="146.54"
            rx="1.45"
            ry="0.19"
            transform="translate(-38.55 38.55) rotate(-17.22)"
            fill="#ffea38"
          />
          <ellipse
            cx="111.96"
            cy="144.99"
            rx="1.46"
            ry="0.19"
            transform="translate(-48.51 56.64) rotate(-23.49)"
            fill="#ffea38"
          />
          <ellipse
            cx="115.48"
            cy="143.44"
            rx="0.96"
            ry="0.12"
            transform="translate(-55.58 75.26) rotate(-29.43)"
            fill="#ffea38"
          />
          <ellipse
            cx="117.89"
            cy="142.02"
            rx="0.96"
            ry="0.12"
            transform="translate(-54.58 76.26) rotate(-29.43)"
            fill="#ffea38"
          />
          <ellipse
            cx="120.12"
            cy="140.48"
            rx="0.76"
            ry="0.1"
            transform="translate(-61.8 107.8) rotate(-39.29)"
            fill="#ffea38"
          />
          <ellipse
            cx="121.56"
            cy="139.18"
            rx="0.76"
            ry="0.1"
            transform="translate(-60.66 108.42) rotate(-39.29)"
            fill="#ffea38"
          />
          <ellipse
            cx="122.88"
            cy="137.89"
            rx="0.4"
            ry="0.09"
            transform="translate(-61.79 134.64) rotate(-47.29)"
            fill="#ffea38"
          />
          <ellipse
            cx="123.84"
            cy="136.86"
            rx="0.4"
            ry="0.09"
            transform="translate(-60.73 135.02) rotate(-47.29)"
            fill="#ffea38"
          />
          <ellipse
            cx="124.8"
            cy="135.83"
            rx="0.4"
            ry="0.09"
            transform="translate(-59.66 135.39) rotate(-47.29)"
            fill="#ffea38"
          />
          <ellipse
            cx="125.64"
            cy="134.67"
            rx="0.4"
            ry="0.09"
            transform="translate(-56.86 159.44) rotate(-54.72)"
            fill="#ffea38"
          />
          <ellipse
            cx="97.18"
            cy="113.77"
            rx="0.19"
            ry="1.44"
            transform="translate(-21.36 205.06) rotate(-87.1)"
            fill="#ffea38"
          />
          <ellipse
            cx="101.51"
            cy="114.15"
            rx="0.19"
            ry="1.44"
            transform="translate(-27.56 195.87) rotate(-80.7)"
            fill="#ffea38"
          />
          <ellipse
            cx="104.87"
            cy="114.96"
            rx="0.19"
            ry="0.84"
            transform="matrix(0.26, -0.97, 0.97, 0.26, -33.18, 186.76)"
            fill="#ffea38"
          />
          <ellipse
            cx="107.63"
            cy="115.73"
            rx="0.19"
            ry="0.84"
            transform="translate(-31.87 190) rotate(-75.11)"
            fill="#ffea38"
          />
          <ellipse
            cx="110.04"
            cy="116.51"
            rx="0.19"
            ry="0.84"
            transform="translate(-30.84 192.9) rotate(-75.11)"
            fill="#ffea38"
          />
          <ellipse
            cx="89.01"
            cy="114.28"
            rx="1.44"
            ry="0.19"
            transform="translate(-17.61 16.23) rotate(-9.48)"
            fill="#ffea38"
          />
          <ellipse
            cx="85.41"
            cy="115.06"
            rx="1.45"
            ry="0.19"
            transform="translate(-24.46 23.07) rotate(-13.48)"
            fill="#ffea38"
          />
          <ellipse
            cx="81.57"
            cy="116.22"
            rx="1.45"
            ry="0.19"
            transform="translate(-30.4 28.91) rotate(-16.99)"
            fill="#ffea38"
          />
          <ellipse
            cx="75.06"
            cy="119.56"
            rx="1.07"
            ry="0.19"
            transform="translate(-51.86 57.76) rotate(-31.92)"
            fill="#ffea38"
          />
          <ellipse
            cx="72.33"
            cy="121.75"
            rx="0.83"
            ry="0.19"
            transform="translate(-60.02 71.37) rotate(-38.44)"
            fill="#ffea38"
          />
          <ellipse cx="97.06" cy="47.45" rx="1.44" ry="0.19" fill="#ffea38" />
          <ellipse cx="100.79" cy="47.45" rx="1.44" ry="0.19" fill="#ffea38" />
          <ellipse
            cx="104.87"
            cy="47.45"
            rx="0.19"
            ry="1.44"
            transform="matrix(0.08, -1, 1, 0.08, 48.88, 148.02)"
            fill="#ffea38"
          />
          <ellipse
            cx="107.75"
            cy="47.79"
            rx="0.19"
            ry="0.84"
            transform="translate(51.14 151.18) rotate(-85.21)"
            fill="#ffea38"
          />
          <ellipse
            cx="130.34"
            cy="55.01"
            rx="0.19"
            ry="0.85"
            transform="matrix(0.53, -0.85, 0.85, 0.53, 14.63, 136.42)"
            fill="#ffea38"
          />
          <ellipse
            cx="132.62"
            cy="56.43"
            rx="0.19"
            ry="0.85"
            transform="translate(14.5 139.02) rotate(-58.01)"
            fill="#ffea38"
          />
          <ellipse
            cx="134.54"
            cy="57.72"
            rx="0.19"
            ry="0.86"
            transform="translate(9.19 133.36) rotate(-54.33)"
            fill="#ffea38"
          />
          <ellipse
            cx="136.22"
            cy="59.14"
            rx="0.19"
            ry="0.86"
            transform="translate(3.9 126.56) rotate(-50.47)"
            fill="#ffea38"
          />
          <ellipse
            cx="138.02"
            cy="60.69"
            rx="0.19"
            ry="0.86"
            transform="translate(3.36 128.51) rotate(-50.47)"
            fill="#ffea38"
          />
          <ellipse
            cx="110.15"
            cy="48.17"
            rx="0.19"
            ry="0.84"
            transform="translate(52.96 153.93) rotate(-85.21)"
            fill="#ffea38"
          />
          <ellipse
            cx="112.56"
            cy="48.69"
            rx="0.19"
            ry="0.84"
            transform="translate(54.65 156.79) rotate(-85.21)"
            fill="#ffea38"
          />
          <ellipse
            cx="93.1"
            cy="47.71"
            rx="1.44"
            ry="0.19"
            transform="translate(-5.08 11.6) rotate(-6.94)"
            fill="#ffea38"
          />
          <ellipse
            cx="88.29"
            cy="48.48"
            rx="1.44"
            ry="0.19"
            transform="translate(-5.21 11.02) rotate(-6.94)"
            fill="#ffea38"
          />
          <ellipse
            cx="83.01"
            cy="49.64"
            rx="1.45"
            ry="0.19"
            transform="translate(-9.67 21.97) rotate(-14.26)"
            fill="#ffea38"
          />
          <ellipse
            cx="77.84"
            cy="51.45"
            rx="1.45"
            ry="0.19"
            transform="translate(-13.28 31.36) rotate(-21.03)"
            fill="#ffea38"
          />
          <path
            d="M75,52.55c0,.1-.39.34-1.14.63s-1.39.44-1.42.34.55-.42,1.3-.7S74.92,52.45,75,52.55Z"
            fill="#ffea38"
          />
          <ellipse
            cx="69.79"
            cy="54.93"
            rx="1.46"
            ry="0.19"
            transform="translate(-17.67 39.48) rotate(-28.18)"
            fill="#ffea38"
          />
          <ellipse
            cx="65.83"
            cy="57.64"
            rx="1.47"
            ry="0.19"
            transform="translate(-21.12 47.81) rotate(-34.75)"
            fill="#ffea38"
          />
          <ellipse cx="103.67" cy="101.51" rx="1.44" ry="0.19" fill="#ffea38" />
          <ellipse
            cx="107.99"
            cy="101.12"
            rx="1.44"
            ry="0.19"
            transform="translate(-12.52 15.31) rotate(-7.66)"
            fill="#ffea38"
          />
          <ellipse
            cx="111.72"
            cy="100.61"
            rx="1.44"
            ry="0.19"
            transform="translate(-12.42 15.8) rotate(-7.66)"
            fill="#ffea38"
          />
          <ellipse
            cx="116.04"
            cy="99.7"
            rx="1.45"
            ry="0.19"
            transform="translate(-19.81 29.34) rotate(-13.29)"
            fill="#ffea38"
          />
          <ellipse
            cx="120.01"
            cy="98.8"
            rx="1.45"
            ry="0.19"
            transform="translate(-22.74 37.27) rotate(-16.15)"
            fill="#ffea38"
          />
          <ellipse
            cx="124.21"
            cy="97.38"
            rx="1.45"
            ry="0.19"
            transform="translate(-22.18 38.38) rotate(-16.15)"
            fill="#ffea38"
          />
          <ellipse
            cx="127.5"
            cy="96.03"
            rx="1.25"
            ry="0.18"
            transform="translate(-27 55.92) rotate(-22.43)"
            fill="#ffea38"
          />
          <ellipse
            cx="130.86"
            cy="94.35"
            rx="1.25"
            ry="0.18"
            transform="translate(-26.1 57.08) rotate(-22.43)"
            fill="#ffea38"
          />
          <ellipse
            cx="134.23"
            cy="92.8"
            rx="1.26"
            ry="0.18"
            transform="translate(-28.31 78.3) rotate(-29.56)"
            fill="#ffea38"
          />
          <ellipse
            cx="136.99"
            cy="90.87"
            rx="1.26"
            ry="0.18"
            transform="translate(-27 79.41) rotate(-29.56)"
            fill="#ffea38"
          />
          <ellipse
            cx="139.36"
            cy="89.14"
            rx="0.92"
            ry="0.18"
            transform="translate(-25.63 101.21) rotate(-36.79)"
            fill="#ffea38"
          />
          <ellipse
            cx="141.16"
            cy="87.72"
            rx="0.92"
            ry="0.18"
            transform="translate(-24.42 102.01) rotate(-36.79)"
            fill="#ffea38"
          />
          <ellipse
            cx="143.32"
            cy="85.91"
            rx="0.93"
            ry="0.18"
            transform="translate(-20.33 119.7) rotate(-42.61)"
            fill="#ffea38"
          />
          <ellipse
            cx="145"
            cy="84.24"
            rx="0.93"
            ry="0.18"
            transform="translate(-18.75 120.4) rotate(-42.61)"
            fill="#ffea38"
          />
          <ellipse
            cx="146.24"
            cy="82.73"
            rx="0.49"
            ry="0.17"
            transform="translate(-9.23 146.44) rotate(-51.78)"
            fill="#ffea38"
          />
          <ellipse
            cx="147.44"
            cy="81.31"
            rx="0.49"
            ry="0.17"
            transform="translate(-7.66 146.84) rotate(-51.78)"
            fill="#ffea38"
          />
          <path
            d="M75.08,51.9s3.36-1.42,3.72-1.42,43.43,6.19,43.43,6.19l.07,1.75Z"
            fill="#efa17b"
          />
          <line x1="122.3" y1="59.45" x2="75.08" y2="52.93" fill="#a05f7e" />
          <path
            d="M118.87,56.19l-6.24.89,6.55.91,2.63-.54.48-.78Z"
            fill="#716f81"
            opacity="0.46"
          />
          <polygon
            points="123.73 58.09 122.34 59.73 122.29 62.61 123.73 59.92 124.81 58.48 123.73 58.09"
            fill="#716f81"
            opacity="0.26"
          />
          <path
            d="M124.81,58.09,86.1,90.87s4.47.93,5.26,1,33.45-33.43,33.45-33.43Z"
            fill="#a05f7e"
          />
          <path
            d="M58.59,65.77l63.7-9.1v1.68L57.74,71.51S56.39,69.32,58.59,65.77Z"
            fill="#efa17b"
          />
          <path
            d="M123.73,58.09,84.78,90.87s4.47.93,5.25,1,34.78-33.82,34.78-33.82Z"
            fill="#efa17b"
          />
          <path
            d="M124.81,56.67H126l12.7,22.42s-2.17,2-3,2.69Z"
            fill="#efa17b"
          />
          <polygon
            points="128.11 67.5 125.29 58.48 124.81 57.45 128.11 75.22 128.11 67.5"
            fill="#716f81"
            opacity="0.26"
          />
          <path
            d="M113.5,49a58.29,58.29,0,0,1,8.67,2.4c.11-1,.07-5.36.1-6.74a73.1,73.1,0,0,0-8.46-2A9.51,9.51,0,0,1,113.5,49Z"
            fill="#716f81"
            opacity="0.46"
          />
          <polygon
            points="125.17 44.8 125.17 50.35 128.11 45.41 128.11 40.81 125.17 44.8"
            fill="#545370"
          />
          <path
            d="M75.08,54l2.53.31c.67-.25,1.36-.49,2.06-.71l-4.59-.64Z"
            fill="#716f81"
            opacity="0.46"
          />
          <path
            d="M57.61,70c0-10.17,18.94-23.28,42.57-23.28,8.24,0,15.46,2.31,22,4.65l.12-1.68A61.18,61.18,0,0,0,86,47c-19.7,4.77-27.39,13.55-29.55,20.38s6.28,12.39,6.28,12.39C59.46,76.59,57.61,73.19,57.61,70Z"
            fill="#b97a95"
            opacity="0.29"
          />
          <path
            d="M117.42,96.15c-31,6.38-63.51-5.25-67.84-27.85-.06.38-.11.75-.15,1.12v2.37c1.25,13.62,24,29,51.36,29,28.17,0,50.62-16.35,50.62-30.19a13.3,13.3,0,0,0-.4-3.17S148.83,89.7,117.42,96.15Z"
            fill="#b97a95"
            opacity="0.29"
          />
          <path
            d="M117.24,57.45s1,1.67-2.52,2.45l-.72,1,8.29-1.73V56.67Z"
            fill="#716f81"
            opacity="0.26"
          />
          <path
            d="M129.62,57.27a2.62,2.62,0,0,1-1.21-3.69l-3.6-1.16V55c1.68.7,3.29,1.46,4.81,2.27Z"
            fill="#716f81"
            opacity="0.26"
          />
          <path
            d="M122.29,51.39,107,48.17c.32,1.67-1.84,2.18-3.16,2.18-.11,0-.08,0,.07.09A61.62,61.62,0,0,1,122.24,54Z"
            fill="#716f81"
            opacity="0.26"
          />
          <path
            d="M109.73,112.33s4.8,2.63,0,4.35c0,0-9.18.5-6.78.5s12.91,3.55,14.47,4.84c0-7.35.12-7.35.12-7.35S116,113.73,109.73,112.33Z"
            fill="#716f81"
            opacity="0.46"
          />
          <path
            d="M119.4,104.8l-2,1.37V102a11.9,11.9,0,0,0,2-.54"
            fill="#716f81"
            opacity="0.26"
          />
          <polygon
            points="125.41 152.82 125.41 153.31 126.49 152.25 126.49 151.76 125.41 152.82"
            fill="#ffea38"
          />
          <polygon
            points="122.89 154.37 122.89 154.86 123.97 153.79 123.97 153.31 122.89 154.37"
            fill="#ffea38"
          />
          <polygon
            points="124.33 159.28 124.33 159.76 125.41 158.7 125.41 158.21 124.33 159.28"
            fill="#ffea38"
          />
          <polygon
            points="121.69 161.6 121.69 162.08 122.77 161.02 122.77 160.53 121.69 161.6"
            fill="#ffea38"
          />
          <polygon
            points="124.33 200.56 124.33 201.05 125.41 199.98 125.41 199.5 124.33 200.56"
            fill="#ffea38"
          />
          <polygon
            points="122.29 204.18 122.29 204.66 123.37 203.59 123.37 203.11 122.29 204.18"
            fill="#ffea38"
          />
          <polygon
            points="123.85 209.21 123.85 209.69 124.93 208.63 124.93 208.14 123.85 209.21"
            fill="#ffea38"
          />
          <polygon
            points="117.6 215.27 117.6 215.75 118.68 214.69 118.68 214.21 117.6 215.27"
            fill="#ffea38"
          />
          <polygon
            points="119.77 214.37 119.77 214.85 120.85 213.79 120.85 213.3 119.77 214.37"
            fill="#ffea38"
          />
          <polygon
            points="117 218.5 117 218.98 118.08 217.91 118.08 217.43 117 218.5"
            fill="#ffea38"
          />
          <polygon
            points="124.33 210.75 124.33 211.24 125.41 210.17 125.41 209.69 124.33 210.75"
            fill="#ffea38"
          />
          <polygon
            points="121.69 212.43 121.69 212.91 122.77 211.85 122.77 211.37 121.69 212.43"
            fill="#ffea38"
          />
          <polygon
            points="121.81 213.59 121.81 214.08 122.89 213.01 122.89 212.53 121.81 213.59"
            fill="#ffea38"
          />
          <polygon
            points="122.29 203.27 122.29 203.75 123.37 202.69 123.37 202.21 122.29 203.27"
            fill="#ffea38"
          />
          <polygon
            points="122.29 201.72 122.29 202.21 123.37 201.14 123.37 200.66 122.29 201.72"
            fill="#ffea38"
          />
          <polygon
            points="118.2 205.72 118.2 206.21 119.28 205.14 119.28 204.66 118.2 205.72"
            fill="#ffea38"
          />
          <polygon
            points="118.2 206.5 118.2 206.98 119.28 205.92 119.28 205.43 118.2 206.5"
            fill="#ffea38"
          />
          <polygon
            points="118.2 207.27 118.2 207.75 119.28 206.69 119.28 206.21 118.2 207.27"
            fill="#ffea38"
          />
          <polygon
            points="117.12 209.21 117.12 209.69 118.2 208.63 118.2 208.14 117.12 209.21"
            fill="#ffea38"
          />
          <polygon
            points="125.17 115.25 125.17 115.89 126.37 114.73 126.37 114.09 125.17 115.25"
            fill="#ffea38"
          />
          <polygon
            points="124.21 112.73 124.21 113.06 124.81 112.47 124.81 112.15 124.21 112.73"
            fill="#ffea38"
          />
          <polygon
            points="125.53 111.57 125.53 111.89 126.13 111.31 126.13 110.99 125.53 111.57"
            fill="#ffea38"
          />
          <polygon
            points="126.37 109.89 126.37 110.22 126.97 109.64 126.97 109.31 126.37 109.89"
            fill="#ffea38"
          />
          <polygon
            points="126.73 106.8 126.73 107.12 127.33 106.54 127.33 106.22 126.73 106.8"
            fill="#ffea38"
          />
          <polygon
            points="124.21 108.86 124.21 109.19 124.81 108.61 124.81 108.28 124.21 108.86"
            fill="#ffea38"
          />
          <path
            d="M128.16,127.29a7.34,7.34,0,0,0-.11-1c-.08.39-3.79,18.3-33,19.71-29.43,1.41-31.24-19.39-31.25-19.56a10,10,0,0,0-.63,3.74c.34,8.82,15.27,19.09,33.23,18.31S128.49,136.11,128.16,127.29Z"
            fill="#b97a95"
            opacity="0.29"
          />
          <path
            d="M68.47,126.22a7.58,7.58,0,0,0,0,2c1.27-6.28,11.51-14.85,26.65-15a43.18,43.18,0,0,1,22.34,6.58v-1.92c-.75-.53-8.65-5.8-22.46-5.56C80.48,112.54,69.31,119.25,68.47,126.22Z"
            fill="#b97a95"
            opacity="0.29"
          />
          <path
            d="M121.92,124.09a6.51,6.51,0,0,1,1,3.06c.15,4-4.38,8.81-11.42,12h0s7.44-2.39,11.06-7.62C125.81,126.84,122.58,124.5,121.92,124.09Z"
            fill="#b97a95"
            opacity="0.29"
          />
          <path
            d="M117.36,122.6v1.77l-.72,0-2.26-.13-1.12-.06-3.6-.21-28.53-1.64-8.1-.46s.58-.51,1.35-1.08h0a8.18,8.18,0,0,1,2.74-1.5,13.69,13.69,0,0,1,1.62,0c6.46.41,30.12,2.53,36.83,3.14Z"
            fill="#a05f7e"
          />
          <path
            d="M117.36,121.44v1.77l-.35,0L113.4,123,80,121.07l-5.66-.32h0l-.23,0L73,120.67s2.65-2.33,4.09-2.58a6.09,6.09,0,0,1,.92,0h.36C85.3,118.53,117.36,121.44,117.36,121.44Z"
            fill="#efa17b"
          />
          <path
            d="M112.7,121a6.28,6.28,0,0,1-3.67,1.71l8.33.52v-1.94Z"
            fill="#716f81"
            opacity="0.46"
          />
          <polygon
            points="117.42 125.09 117.42 127.4 119.41 124.28 119.41 123.25 118.68 123.38 117.42 125.09"
            fill="#716f81"
            opacity="0.5"
          />
          <path
            d="M109.07,122.73s.12,1-2.16,1c-1.56,0,7.33.39,7.33.39V123Z"
            fill="#716f81"
            opacity="0.46"
          />
          <path
            d="M117.48,122l-.11,1.14v.15l-3,1-20.56,6.54h0l-10.89,3.47L74,137a1.48,1.48,0,0,1-.65-.22l0,0a8.08,8.08,0,0,1-1.86-1.5l0,0-.57-.6c-.22-.25-.45-.51-.69-.8l9.1-2.29L90,128.88h0l19.66-4.95,3.74-1,2.17-.54,1.79-.45Z"
            fill="#efa17b"
          />
          <polygon
            points="118.68 122.73 104.87 141.44 108.83 140.28 119.41 123.64 119.41 122.6 118.68 122.73"
            fill="#a05f7e"
          />
          <path
            d="M114.24,122.73a3.73,3.73,0,0,1-2.64,2.35c.72,1-1.56,1.67-1.56,1.67l7.32-2.34.12-2.45Z"
            fill="#716f81"
            opacity="0.46"
          />
          <polygon
            points="73.04 120.67 73.04 121.83 75.06 121.96 75.06 120.78 73.04 120.67"
            fill="#b97a95"
          />
          <polygon
            points="119.4 122.6 111.09 135.44 107.72 140.67 107.63 140.79 103.79 141.83 103.84 141.76 108.73 135.1 116.34 124.74 116.64 124.33 117.36 123.35 117.59 123.04 117.72 122.86 119.4 122.6"
            fill="#efa17b"
          />
          <path
            d="M118.62,123.81s-.78-.67-2.28.93l1.38-1.88,1.68-.26Z"
            fill="#716f81"
            opacity="0.46"
          />
          <path
            d="M106.63,138s-1.2,2.45,1.58,1.93l-.46.77-4,1.16Z"
            fill="#716f81"
            opacity="0.26"
          />
          <path
            d="M128.59,177.44a21.32,21.32,0,0,0-.22-3.31c-1.12,5.93-7.65,24-45.84,22.92-45.65-1.29-42.77-24.84-42.77-24.84h0a11.84,11.84,0,0,0-1.26,5.23c0,12.22,20.17,22.12,45.05,22.12S128.59,189.66,128.59,177.44Z"
            fill="#b97a95"
            opacity="0.29"
          />
          <path
            d="M38.5,177.31a12.81,12.81,0,0,0,.61,3.31,14.47,14.47,0,0,0,1.47,3,20.53,20.53,0,0,0,4.6,4.84,41.17,41.17,0,0,0,11.87,6.17,80.73,80.73,0,0,0,26.5,4.11,80.81,80.81,0,0,0,26.5-4.11,41.43,41.43,0,0,0,11.87-6.17,20.49,20.49,0,0,0,4.59-4.84,14.47,14.47,0,0,0,1.47-3,12.4,12.4,0,0,0,.61-3.31,12.44,12.44,0,0,1-.41,3.37,14.55,14.55,0,0,1-1.36,3.14,21.1,21.1,0,0,1-4.48,5.17,41.9,41.9,0,0,1-11.94,6.64,79.18,79.18,0,0,1-26.85,4.49,79.48,79.48,0,0,1-26.86-4.49A42,42,0,0,1,44.76,189a20.69,20.69,0,0,1-4.48-5.17,14.59,14.59,0,0,1-1.37-3.14A12.85,12.85,0,0,1,38.5,177.31Z"
            fill="#545370"
          />
          <path
            d="M45.77,177.18a7.8,7.8,0,0,1,1-3.76,14.63,14.63,0,0,0-.59,3.85,11.89,11.89,0,0,0,.3,3.07,7.23,7.23,0,0,1-.71-3A.57.57,0,0,1,45.77,177.18Z"
            fill="#b97a95"
            opacity="0.29"
          />
          <path
            d="M117.48,169.18c-4.41-3.31-12-5.93-20.78-7.27a86.86,86.86,0,0,0-9.35-.91h0c-1.25-.05-2.52-.08-3.79-.08q-3.87,0-7.52.33h0a75.65,75.65,0,0,0-7.78,1.07c-10.66,2-18.71,6.13-21.45,11.1,1.86-6.24,9-14.43,33.71-14.43q5.58,0,10.26.42h0A76.65,76.65,0,0,1,101,160.94c7.65,1.71,12.85,4.37,16.4,7.37a1.48,1.48,0,0,0,0,.21C117.44,168.76,117.46,169,117.48,169.18Z"
            fill="#b97a95"
            opacity="0.29"
          />
          <path
            d="M114.46,161.6c-.5-.22-3,1.44-7.27,1.09s-3.86.81-3.86.81a4.27,4.27,0,0,1-3.31.65c-2-.39,14.7,2.71,17.46,7l-.12-8A16.51,16.51,0,0,0,114.46,161.6Z"
            fill="#716f81"
            opacity="0.26"
          />
          <ellipse cx="81.69" cy="199.43" rx="1.44" ry="0.19" fill="#ffea38" />
          <ellipse
            cx="76.4"
            cy="199.18"
            rx="0.19"
            ry="1.44"
            transform="translate(-128.25 259.4) rotate(-85.41)"
            fill="#ffea38"
          />
          <ellipse
            cx="71.59"
            cy="198.66"
            rx="0.19"
            ry="1.44"
            transform="translate(-134.38 245.21) rotate(-82.92)"
            fill="#ffea38"
          />
          <ellipse
            cx="66.91"
            cy="197.88"
            rx="0.19"
            ry="1.44"
            transform="translate(-139.59 229.39) rotate(-79.99)"
            fill="#ffea38"
          />
          <ellipse
            cx="62.1"
            cy="196.72"
            rx="0.19"
            ry="1.45"
            transform="translate(-144.01 205.25) rotate(-74.85)"
            fill="#ffea38"
          />
          <ellipse
            cx="58.26"
            cy="195.69"
            rx="0.19"
            ry="1.45"
            transform="translate(-145.83 189.56) rotate(-71.7)"
            fill="#ffea38"
          />
          <ellipse
            cx="54.78"
            cy="194.36"
            rx="0.16"
            ry="0.83"
            transform="translate(-146.94 185.16) rotate(-71.65)"
            fill="#ffea38"
          />
          <ellipse
            cx="52.62"
            cy="193.33"
            rx="0.16"
            ry="0.84"
            transform="translate(-145.85 165.83) rotate(-66.88)"
            fill="#ffea38"
          />
          <ellipse
            cx="50.1"
            cy="192.04"
            rx="0.16"
            ry="0.84"
            transform="translate(-144.81 154.6) rotate(-64.51)"
            fill="#ffea38"
          />
          <ellipse
            cx="47.82"
            cy="190.75"
            rx="0.16"
            ry="0.84"
            transform="matrix(0.53, -0.85, 0.85, 0.53, -139.35, 130.42)"
            fill="#ffea38"
          />
          <ellipse
            cx="45.65"
            cy="189.2"
            rx="0.16"
            ry="0.84"
            transform="translate(-139.06 127.85) rotate(-58.06)"
            fill="#ffea38"
          />
          <ellipse
            cx="43.73"
            cy="187.78"
            rx="0.16"
            ry="0.47"
            transform="translate(-122.01 89.28) rotate(-46.17)"
            fill="#ffea38"
          />
          <ellipse
            cx="86.61"
            cy="199.43"
            rx="1.44"
            ry="0.19"
            transform="translate(-11.65 5.48) rotate(-3.39)"
            fill="#ffea38"
          />
          <ellipse
            cx="91.06"
            cy="199.18"
            rx="1.44"
            ry="0.19"
            transform="translate(-11.63 5.74) rotate(-3.39)"
            fill="#ffea38"
          />
          <ellipse
            cx="95.26"
            cy="198.66"
            rx="1.44"
            ry="0.19"
            transform="translate(-11.59 5.99) rotate(-3.39)"
            fill="#ffea38"
          />
          <ellipse
            cx="99.34"
            cy="198.01"
            rx="1.44"
            ry="0.19"
            transform="translate(-33.36 20.62) rotate(-10.16)"
            fill="#ffea38"
          />
          <ellipse
            cx="103.55"
            cy="197.24"
            rx="1.44"
            ry="0.19"
            transform="translate(-33.16 21.35) rotate(-10.16)"
            fill="#ffea38"
          />
          <ellipse
            cx="107.01"
            cy="196.2"
            rx="1.05"
            ry="0.14"
            transform="translate(-53.77 40.97) rotate(-17.4)"
            fill="#ffea38"
          />
          <ellipse
            cx="109.77"
            cy="195.3"
            rx="1.05"
            ry="0.14"
            transform="translate(-53.37 41.75) rotate(-17.4)"
            fill="#ffea38"
          />
          <ellipse
            cx="113.01"
            cy="194.01"
            rx="1.05"
            ry="0.14"
            transform="translate(-52.84 42.66) rotate(-17.4)"
            fill="#ffea38"
          />
          <ellipse
            cx="116.14"
            cy="192.59"
            rx="1.05"
            ry="0.14"
            transform="translate(-67.31 62.49) rotate(-23.56)"
            fill="#ffea38"
          />
          <path
            d="M117.48,171.11v1.29l-.65.11-35.65,5.67-5.36.85L48.6,183.36h-.07a9.16,9.16,0,0,1-.59-.75l-.28-.43a5,5,0,0,1-.93-3.72l28.56-3,5.25-.54,33.66-3.5Z"
            fill="#a05f7e"
          />
          <path
            d="M117.48,169.18v1.66l-2.59-.43h0c-5.09-.84-16.74-2.74-27.13-4.5l-6.12-1c-4.86-.84-9-1.57-11.33-2h0a12.63,12.63,0,0,1-2.07-.49v0c-.06-.52,5.91-1.27,7.33-1.14l.45.07h0c1.16.19,4.3.77,8.34,1.54L91,164.07C103,166.36,117.48,169.18,117.48,169.18Z"
            fill="#efa17b"
          />
          <path
            d="M110.78,167.88c1.06,1-1.67,1.6-2.11,1.51a3.54,3.54,0,0,1-2.47.76l7.2,1.22,4.08-1v-1.16Z"
            fill="#716f81"
            opacity="0.26"
          />
          <path
            d="M117.48,170.15v1l-2.73.44-34,5.4-5.24.83-27.81,4.41h-.09c-2.4-2.84-1.8-4.9-1.8-4.9h0l.41,0,29.25-2.92,5.33-.54,29.7-3,4.41-.43,2-.2Z"
            fill="#efa17b"
          />
          <path
            d="M113.17,170.58c.47.28-.81,1.27-1.25,1.42a2,2,0,0,1-1.52,1.53l7.08-1.13v-2.32Z"
            fill="#716f81"
            opacity="0.26"
          />
          <path
            d="M119.4,172.66l-21.48,15.5-5.7,4.11-1.16.84h0l-.32,0-.3,0-1.34.09-.56,0-.3,0-.63,0c-1.84.11-4.06.19-5.65.15a12.29,12.29,0,0,1-1.42-.11l-.29,0,6.27-3.56,5.7-3.25,24.62-14,.53-.3.12,0Z"
            fill="#efa17b"
          />
          <path
            d="M114,202.34s0,6.45-7.39,13.41L107,199.5Z"
            fill="#716f81"
            opacity="0.43"
          />
          <path
            d="M113.94,174.16s2.64-1.09,3.39,0c0,0,2-.79,1.35.28l.68-.47v-1.31l-2-.51Z"
            fill="#716f81"
            opacity="0.26"
          />
          <path
            d="M85.48,190.35l-5.24,3c1.77.43,8.6-.05,10.38-.18C88,192.91,85.18,191.68,85.48,190.35Z"
            fill="#716f81"
            opacity="0.26"
          />
          <g>
            <path
              d="M160.61,146.6c-1.41-12.35-5-33.39-9.73-39.35-3.33-4.18-5.89-6.58-7.33-7l-.13.2s-.35,19.41.49,20.57S157.59,123.51,160.61,146.6Z"
              fill="#ff7314"
            />
            <path
              d="M147.37,103.21h0l-1.7-1.61a6.28,6.28,0,0,0-2.12-1.32l-.13.2s-.35,19.41.49,20.57c.25.34,1.61.7,3.46,1.69Z"
              fill="#db681b"
            />
            <path
              d="M160.6,146.58c-1.41-12.35-4.43-32.66-9.18-38.62-3.33-4.18-5.56-6.48-6.92-7.35h0s-.35,17.48.49,18.64S157.58,123.49,160.6,146.58Z"
              fill="#7163c1"
            />
            <path
              d="M160.94,149.7c.09,1.06.19,2,.28,2.8C161.14,151.67,161.05,150.73,160.94,149.7Z"
              fill="#45bcff"
            />
          </g>
          <path
            d="M146.07,118c-.66-.91-.59-11.87-.52-16.55a9.81,9.81,0,0,0-1.05-.8s-.35,17.48.49,18.64,12.59,4.24,15.61,27.33c-.45-3.92-1.06-8.65-1.84-13.46C154.16,121,146.71,118.84,146.07,118Z"
            fill="#af5d4e"
            opacity="0.89"
          />
          <path
            d="M147.51,106.6c-.48.91.36,3.23,1.33,3.75s3.72,4.9,4.08,7.48c0,0,1.32-1.29,0-4.65s-4-5-4.2-5.8S147.51,106.6,147.51,106.6Z"
            fill="#edf4f9"
            opacity="0.71"
          />
          <ellipse cx="142.77" cy="172.47" rx="4.02" ry="0.97" fill="#aa551b" />
          <ellipse cx="142.77" cy="172.47" rx="1.34" ry="0.32" fill="#93440f" />
          <polygon
            points="143.24 172.17 143.84 171.85 144.47 171.59 143.87 171.91 143.24 172.17"
            fill="#93440f"
          />
          <polygon
            points="144.15 172.4 145.35 172.24 146.56 172.15 145.36 172.31 144.15 172.4"
            fill="#93440f"
          />
          <polygon
            points="143.85 172.66 144.62 172.9 145.36 173.21 144.59 172.96 143.85 172.66"
            fill="#93440f"
          />
          <polygon
            points="142.71 172.79 143 173.09 143.24 173.43 142.95 173.13 142.71 172.79"
            fill="#93440f"
          />
          <polygon
            points="141.69 172.66 140.47 172.83 139.24 172.93 140.46 172.76 141.69 172.66"
            fill="#93440f"
          />
          <polygon
            points="141.7 172.28 140.34 172.24 138.97 172.15 140.34 172.18 141.7 172.28"
            fill="#93440f"
          />
          <polygon
            points="142.3 172.17 141.71 171.9 141.15 171.58 141.74 171.85 142.3 172.17"
            fill="#93440f"
          />
          <polygon
            points="142.71 172.15 142.68 171.82 142.71 171.5 142.74 171.82 142.71 172.15"
            fill="#93440f"
          />
          <path
            d="M139.61,199.39a2.72,2.72,0,0,0,1.42.75c2.4.13.36-.64.36-.64-8.53-11.74,0-24,0-24-.92,0-2.08-1.66-1.67-2.37l-.41-.19c-2,2.62-3.43,7.31-3.43,13C135.92,191.76,137.42,196.85,139.61,199.39Z"
            fill="#af5d4e"
            opacity="0.89"
          />
          <path
            d="M138.75,172.4c.24.78,5.52,1.81,8,0a1.54,1.54,0,0,1,.27,1.63c-.48,1.62-6.63,2.24-8.68.31C137.71,173.7,138.75,172.4,138.75,172.4Z"
            fill="#f9893d"
          />
          <g>
            <path
              d="M141.43,173.32c-1.44-.17-2.58-.57-2.68-.92,0,0-1,1.3-.37,1.94,1,.92,2.86,1.26,4.63,1.19h0C141.9,175.49,140.48,174,141.43,173.32Z"
              fill="#005c9c"
              opacity="0.26"
            />
            <path
              d="M143.24,175.52h0c.33,0,.18,0-.2,0h.2Z"
              fill="#005c9c"
              opacity="0.26"
            />
          </g>
          <g>
            <polygon
              points="143.69 200.81 143.69 200.81 143.69 200.81 143.69 200.81"
              fill="#005c9c"
              opacity="0.26"
            />
            <path
              d="M143.47,200.83c-1.13,0-1.69-.69-2-.69-1.44,0-1.8-.77-1.8-.77q-.54.23-.54.51c0,.54,1.57,1,3.51,1Z"
              fill="#005c9c"
              opacity="0.26"
            />
          </g>
          <path
            d="M147.15,176.92s3.49,11.74-.48,16.9c-1-1.29,2.29-1.68-1.32-16.9A1,1,0,0,1,147.15,176.92Z"
            fill="#edf4f9"
            opacity="0.42"
          />
          <path
            d="M145.35,173.44c.6,0,1.08-.52,1.2-.39s.48,1.29-.6,1.42S145.35,173.44,145.35,173.44Z"
            fill="#edf4f9"
            opacity="0.42"
          />
          <g opacity="0.56">
            <path
              d="M137.72,196.18a11.27,11.27,0,0,0,2.45,1,10,10,0,0,0,2.61.37,8.43,8.43,0,0,0,2.59-.35,11.56,11.56,0,0,0,2.44-1,8.88,8.88,0,0,1-2.38,1.2,7.75,7.75,0,0,1-2.66.41A9,9,0,0,1,137.72,196.18Z"
              fill="#edf4f9"
            />
          </g>
          <g opacity="0.56">
            <path
              d="M137.48,175.79a11.83,11.83,0,0,0,2.45,1,10,10,0,0,0,2.6.36,8.45,8.45,0,0,0,2.6-.34,11.6,11.6,0,0,0,2.44-1,9.21,9.21,0,0,1-2.38,1.21,8,8,0,0,1-2.66.41A9.08,9.08,0,0,1,137.48,175.79Z"
              fill="#edf4f9"
            />
          </g>
          <g opacity="0.56">
            <path
              d="M136.84,193.5a5.92,5.92,0,0,0,.94.55,5.7,5.7,0,0,0,1,.37,8.3,8.3,0,0,0,2.13.3,4.52,4.52,0,0,1-1.1.11,5.14,5.14,0,0,1-1.1-.17A3.81,3.81,0,0,1,136.84,193.5Z"
              fill="#edf4f9"
            />
          </g>
          <g opacity="0.56">
            <path
              d="M137.08,178.15a5.56,5.56,0,0,0,.94.54,5.73,5.73,0,0,0,1,.38,8.76,8.76,0,0,0,2.13.3,4.51,4.51,0,0,1-1.1.1,5.12,5.12,0,0,1-1.1-.16A3.89,3.89,0,0,1,137.08,178.15Z"
              fill="#edf4f9"
            />
          </g>
          <g opacity="0.56">
            <path
              d="M148.61,193.82a4.12,4.12,0,0,1-2,.85,7.61,7.61,0,0,1-1.07.11,6.4,6.4,0,0,1-1.07-.06c.71-.1,1.41-.16,2.1-.3a7.48,7.48,0,0,0,1-.23A5.05,5.05,0,0,0,148.61,193.82Z"
              fill="#edf4f9"
            />
          </g>
          <g opacity="0.56">
            <path
              d="M148.61,178.34a4,4,0,0,1-2,.84,9.46,9.46,0,0,1-1.07.12,6.4,6.4,0,0,1-1.07-.06c.71-.1,1.41-.16,2.1-.3a9.35,9.35,0,0,0,1-.23A5.05,5.05,0,0,0,148.61,178.34Z"
              fill="#edf4f9"
            />
          </g>
          <ellipse cx="152.44" cy="140.6" rx="1.8" ry="6" fill="#7163c1" />
          <path
            d="M152.56,134.6a.93.93,0,0,1,.69.41,3.47,3.47,0,0,1,.42.72,8,8,0,0,1,.49,1.58,16.57,16.57,0,0,1,0,6.58,8,8,0,0,1-.49,1.58,3.23,3.23,0,0,1-.42.72.93.93,0,0,1-.69.41.88.88,0,0,0,.64-.45,3.23,3.23,0,0,0,.36-.72,8.53,8.53,0,0,0,.41-1.58,18.6,18.6,0,0,0,.27-3.25,19.61,19.61,0,0,0-.26-3.25,9.07,9.07,0,0,0-.42-1.57,3.1,3.1,0,0,0-.36-.73A.88.88,0,0,0,152.56,134.6Z"
            fill="#ff7314"
          />
          <ellipse
            cx="158.69"
            cy="163.31"
            rx="0.72"
            ry="2.39"
            fill="#af5d4e"
            opacity="0.89"
          />
          <ellipse cx="158.69" cy="163.31" rx="0.48" ry="1.59" fill="#7163c1" />
          <ellipse
            cx="158.69"
            cy="170.15"
            rx="0.72"
            ry="2.39"
            fill="#af5d4e"
            opacity="0.89"
          />
          <ellipse
            cx="158.69"
            cy="176.98"
            rx="0.72"
            ry="2.39"
            fill="#af5d4e"
            opacity="0.89"
          />
          <ellipse
            cx="158.69"
            cy="183.82"
            rx="0.72"
            ry="2.39"
            fill="#af5d4e"
            opacity="0.89"
          />
          <ellipse
            cx="158.69"
            cy="190.66"
            rx="0.72"
            ry="2.39"
            fill="#af5d4e"
            opacity="0.89"
          />
          <ellipse cx="152.56" cy="174.4" rx="1.8" ry="6" fill="#7163c1" />
          <ellipse cx="152.56" cy="157.24" rx="1.8" ry="6" fill="#7163c1" />
          <path
            d="M154.24,140.6a12.39,12.39,0,0,0-.93-5.26h0s.84,10-2.06,9.77h0c.32.93.73,1.49,1.19,1.49C153.43,146.6,154.24,143.91,154.24,140.6Z"
            fill="#af5d4e"
            opacity="0.89"
          />
          <path
            d="M154.36,157.37a12.34,12.34,0,0,0-.93-5.25h0s.84,9.95-2.06,9.76h0c.32.93.73,1.49,1.19,1.49C153.55,163.37,154.36,160.69,154.36,157.37Z"
            fill="#af5d4e"
            opacity="0.89"
          />
          <path
            d="M154.36,174.4a12.34,12.34,0,0,0-.93-5.25h0s.84,9.95-2.06,9.76h0c.32.93.73,1.49,1.19,1.49C153.55,180.4,154.36,177.72,154.36,174.4Z"
            fill="#af5d4e"
            opacity="0.89"
          />
          <path
            d="M154.1,138.24l-3.46,2.3,0,1.06Z"
            fill="#edf4f9"
            opacity="0.71"
          />
          <path
            d="M154.34,155.14l-3.46,2.3,0,1.06Z"
            fill="#edf4f9"
            opacity="0.71"
          />
          <polygon
            points="150.76 142.75 154.2 139.38 150.92 143.81 150.76 142.75"
            fill="#edf4f9"
            opacity="0.71"
          />
          <polygon
            points="150.76 174.88 153.15 170.24 150.92 175.94 150.76 174.88"
            fill="#edf4f9"
            opacity="0.71"
          />
          <ellipse cx="158.69" cy="170.15" rx="0.48" ry="1.59" fill="#7163c1" />
          <ellipse cx="158.69" cy="176.98" rx="0.48" ry="1.59" fill="#7163c1" />
          <ellipse cx="158.69" cy="183.95" rx="0.48" ry="1.59" fill="#7163c1" />
          <ellipse cx="158.69" cy="190.66" rx="0.48" ry="1.59" fill="#7163c1" />
          <path
            d="M152.56,168.4a.92.92,0,0,1,.69.42,3.16,3.16,0,0,1,.42.71,8.24,8.24,0,0,1,.49,1.58,16.57,16.57,0,0,1,0,6.58,8.12,8.12,0,0,1-.49,1.59,3.4,3.4,0,0,1-.42.71.88.88,0,0,1-.69.41.86.86,0,0,0,.64-.45,3.23,3.23,0,0,0,.36-.72,8.64,8.64,0,0,0,.41-1.57,18.79,18.79,0,0,0,.27-3.26,19.61,19.61,0,0,0-.26-3.25,9.32,9.32,0,0,0-.42-1.57,3.3,3.3,0,0,0-.36-.73A.88.88,0,0,0,152.56,168.4Z"
            fill="#ff7314"
          />
          <path
            d="M152.56,151.24a.92.92,0,0,1,.69.42,3.4,3.4,0,0,1,.42.71,8.12,8.12,0,0,1,.49,1.59,16.52,16.52,0,0,1,0,6.57,8.12,8.12,0,0,1-.49,1.59,3.4,3.4,0,0,1-.42.71.88.88,0,0,1-.69.41.87.87,0,0,0,.64-.44,3.3,3.3,0,0,0,.36-.73,8.64,8.64,0,0,0,.41-1.57,18.79,18.79,0,0,0,.27-3.26A19.61,19.61,0,0,0,154,154a9.58,9.58,0,0,0-.42-1.57,3.3,3.3,0,0,0-.36-.73A.88.88,0,0,0,152.56,151.24Z"
            fill="#ff7314"
          />
          <g>
            <ellipse
              cx="168.16"
              cy="233.33"
              rx="2.02"
              ry="2.17"
              fill="#af5d4e"
              opacity="0.89"
            />
            <path
              d="M170.18,234.18a13,13,0,0,1,6.88,7.32l-.14,1.94S172.48,234.58,170.18,234.18Z"
              fill="#af5d4e"
              opacity="0.89"
            />
            <path
              d="M169,235.44s4.09,2.19,4.16,6.45l-.74,1.43S171,236.07,169,235.44Z"
              fill="#af5d4e"
              opacity="0.89"
            />
            <path
              d="M170.64,233.16s4.47-1,7,2.22l.26,1.61S172.59,232.28,170.64,233.16Z"
              fill="#af5d4e"
              opacity="0.89"
            />
          </g>
          <polygon
            points="128.11 114.91 141.15 114.99 141.99 117.18 141.15 119.24 128.11 119.24 127.09 117.06 128.11 114.91"
            fill="#efa17b"
          />
          <polygon
            points="127.09 117.06 141.99 117.18 141.15 119.25 128.17 119.25 127.09 117.06"
            fill="#545370"
          />
          <polygon
            points="127.87 216.83 140.91 216.91 141.75 219.11 140.91 221.16 127.87 221.16 126.85 218.98 127.87 216.83"
            fill="#efa17b"
          />
          <polygon
            points="126.85 218.98 141.75 219.11 140.91 221.17 127.93 221.17 126.85 218.98"
            fill="#545370"
          />
          <path
            d="M80.71,177a6.2,6.2,0,0,0,.47,1.23l-5.36.85a9.73,9.73,0,0,1-.35-1.25,9.26,9.26,0,0,1-.18-1.45,7.68,7.68,0,0,1,.15-2l5.33-.54a6.89,6.89,0,0,0-.23,1.15,6.43,6.43,0,0,0,0,.76A5.24,5.24,0,0,0,80.71,177Z"
            fill="#716f81"
            opacity="0.46"
          />
          <path
            d="M84.36,162.79,91,164.07c-.57.27-1.11.56-1.63.85h0q-.86.47-1.65,1c-.47.3-.91.61-1.35.93l-5.84-1c.34-.33.7-.66,1.07-1s.94-.77,1.44-1.15S83.91,163.09,84.36,162.79Z"
            fill="#716f81"
            opacity="0.46"
          />
          <path
            d="M112.56,160.77a38.84,38.84,0,0,0-15.86,1.14,86.86,86.86,0,0,0-9.35-.91c1.08-.57,2.21-1.1,3.4-1.59h0A41.38,41.38,0,0,1,99.35,157,66.72,66.72,0,0,1,112.56,160.77Z"
            fill="#716f81"
            opacity="0.46"
          />
          <path
            d="M99.29,188.43l-5.88,4.24-1.19-.4a38.38,38.38,0,0,1-4.61-1.93l-1.1-.57,5.7-3.25,1.39.5a40.6,40.6,0,0,0,4.32,1.14C98.38,188.26,98.83,188.35,99.29,188.43Z"
            fill="#716f81"
            opacity="0.46"
          />
          <path
            d="M127,183.61c-2.31,4.08-6.93,7.69-13.13,10.47a46,46,0,0,1-5.33.55,44,44,0,0,1-14.62-1.82,61.47,61.47,0,0,0,15.81-3.9h0A40,40,0,0,0,127,183.61Z"
            fill="#716f81"
            opacity="0.46"
          />
          <path
            d="M73,121.83s.58-.51,1.35-1.08l-.23,0a20.62,20.62,0,0,0-2.66,2.33,21,21,0,0,1-2.11-4.29A32.15,32.15,0,0,1,76.76,114,10.68,10.68,0,0,0,78,118.11l.08.15c.19.35.39.7.62,1a17,17,0,0,0,1.3,1.77c.34.41.7.82,1.09,1.22Z"
            fill="#716f81"
            opacity="0.46"
          />
          <path
            d="M93.82,130.74c.52.23,1,.46,1.57.67L84.13,135c-.41-.25-.81-.51-1.21-.78q-1.32-.87-2.52-1.8c-.37-.28-.74-.56-1.09-.84L90,128.88h0l1.45.75c.76.38,1.55.75,2.36,1.11Z"
            fill="#716f81"
            opacity="0.46"
          />
          <path
            d="M119.46,136c1.77,0,3.52-.08,5.24-.21a33.42,33.42,0,0,1-11.9,8.75A69.79,69.79,0,0,1,101,142.32c1-.16,2-.35,2.89-.56l4.89-6.66c.77.13,1.57.24,2.36.34l-3.37,5.23a34,34,0,0,0,9.35-4.75C117.87,136,118.66,136,119.46,136Z"
            fill="#716f81"
            opacity="0.46"
          />
          <path
            d="M158.64,132.36a59,59,0,0,1-15.46,8.29,3.4,3.4,0,0,1-.34.12c-.56.21-1.12.4-1.69.59v-9.05c.57-.19,1.12-.4,1.67-.61l.28-.11a43.34,43.34,0,0,0,13.81-8.35C157.56,126.18,158.13,129.28,158.64,132.36Z"
            fill="#716f81"
            opacity="0.46"
          />
          <path
            d="M182,254s3,5,4,5.48S200,257,205,257s-6-8-6-8v-7l-2,3Z"
            fill="#141c66"
            opacity="0.72"
          />
          <g opacity="0.72">
            <ellipse
              cx="247.98"
              cy="252.91"
              rx="4.21"
              ry="5.2"
              transform="translate(-66.05 416.75) rotate(-73.12)"
              fill="#141c66"
              opacity="0.79"
            />
            <line
              x1="246.95"
              y1="256.98"
              x2="207"
              y2="247"
              fill="none"
              stroke="#141c66"
              strokeMiterlimit="10"
              opacity="0.79"
            />
            <line
              x1="249.2"
              y1="248.88"
              x2="221"
              y2="237"
              fill="none"
              stroke="#141c66"
              strokeMiterlimit="10"
              opacity="0.79"
            />
            <line
              x1="247.98"
              y1="252.91"
              x2="223"
              y2="245"
              fill="none"
              stroke="#141c66"
              strokeMiterlimit="10"
              opacity="0.79"
            />
            <g>
              <circle cx="219.84" cy="219.04" r="6.04" fill="#aaa8c6" />
              <line
                x1="213.84"
                y1="218.81"
                x2="206.32"
                y2="247.28"
                fill="none"
                stroke="#aaa8c6"
                strokeMiterlimit="10"
                strokeWidth="0.34"
              />
              <line
                x1="225.88"
                y1="219.04"
                x2="233.85"
                y2="247.51"
                fill="none"
                stroke="#aaa8c6"
                strokeMiterlimit="10"
                strokeWidth="0.34"
              />
              <path
                d="M224,214.64c0,.06-.54,10.42-9.75,6.59a6,6,0,1,0,9.75-6.59Z"
                fill="#6565a5"
              />
              <line
                x1="219.84"
                y1="219.04"
                x2="220.75"
                y2="254"
                fill="none"
                stroke="#aaa8c6"
                strokeMiterlimit="10"
                strokeWidth="0.34"
              />
              <path
                d="M215.57,217.73c-1.42-.56,2.39-4.45,4.44-3.88C222.44,214.53,220.24,219.55,215.57,217.73Z"
                fill="#ded3ef"
              />
            </g>
          </g>
        </g>
        <g className="text" transform="translate(40 66)">
          <path
            d="M75.68,229.73a.68.68,0,0,1-.42-.18.75.75,0,0,1-.19-.33,2.85,2.85,0,0,1,0-.4v-.36c0-.25,0-.51,0-.77s.06-.52.1-.76a.63.63,0,0,1,.14-.33.36.36,0,0,1,.31-.13,1.16,1.16,0,0,1,.27,0l.32.08.62.08a8.5,8.5,0,0,0,1,.05,8,8,0,0,0,1.1-.07,4.44,4.44,0,0,0,1-.21,1.89,1.89,0,0,0,.69-.37.69.69,0,0,0,.27-.55c0-.17-.19-.31-.55-.41s-.83-.21-1.37-.31-1.14-.22-1.78-.38a7.12,7.12,0,0,1-1.78-.66A4.13,4.13,0,0,1,74,222.61a2.91,2.91,0,0,1-.55-1.85,3.26,3.26,0,0,1,.62-2,4.73,4.73,0,0,1,1.61-1.38,8,8,0,0,1,2.25-.8,13,13,0,0,1,2.56-.25h.68l.68.06.1-.45a.77.77,0,0,1,.16-.29.43.43,0,0,1,.35-.15,6.75,6.75,0,0,1,2,.27.69.69,0,0,1,.43.3.72.72,0,0,1,.1.34c0,.46,0,.87-.07,1.24s-.06.72-.1,1.05-.08.63-.13.93l-.15.93a.9.9,0,0,1-.2.43.65.65,0,0,1-.5.18,9.17,9.17,0,0,1-1,0A4.67,4.67,0,0,1,82,221a.46.46,0,0,1-.33-.25.87.87,0,0,1-.11-.41c0-.15,0-.31,0-.46a3.4,3.4,0,0,1,0-.45,6.77,6.77,0,0,0-.73-.08l-.7,0a7.62,7.62,0,0,0-1.11.08,4.78,4.78,0,0,0-.9.21,1.58,1.58,0,0,0-.59.34.61.61,0,0,0-.22.45c0,.26.17.44.52.56a9.73,9.73,0,0,0,1.3.33l1.7.37a7,7,0,0,1,1.69.65,3.71,3.71,0,0,1,1.3,1.16,3.19,3.19,0,0,1,.52,1.92,3.77,3.77,0,0,1-.49,1.93,4.56,4.56,0,0,1-1.34,1.43,6.42,6.42,0,0,1-2,.89,10.23,10.23,0,0,1-2.54.3A13.4,13.4,0,0,1,75.68,229.73Z"
            fill="#fff"
          />
          <path
            d="M91.4,220.35c.29,0,.59,0,.91.05a4,4,0,0,1,1,.25,1.45,1.45,0,0,1,.62.4,1.41,1.41,0,0,1,.25.76c0,.2,0,.39.06.58s0,.36,0,.54a7.2,7.2,0,0,1-.12,1.32,1,1,0,0,1-.22.54.73.73,0,0,1-.54.15,6,6,0,0,1-1-.08,1,1,0,0,1-.85-.89,4.8,4.8,0,0,1-.06-.56c0-.2,0-.39,0-.58a3.26,3.26,0,0,0-1,.23,3,3,0,0,0-.8.48,2.23,2.23,0,0,0-.54.69,1.87,1.87,0,0,0-.2.88A2.4,2.4,0,0,0,89,226a2.12,2.12,0,0,0,1.13,1.2,2.25,2.25,0,0,0,.92.18,2.78,2.78,0,0,0,.54-.06c.19,0,.39-.09.58-.15l.53-.2.41-.2.36-.16a.53.53,0,0,1,.25-.07c.17,0,.32.12.46.36l.22.44a4,4,0,0,1,.21.47l.1.31a1.51,1.51,0,0,1,0,.26.77.77,0,0,1-.31.55,3.49,3.49,0,0,1-.68.45,6.86,6.86,0,0,1-.87.35,6.35,6.35,0,0,1-1,.23,5.63,5.63,0,0,1-1,.09,7.25,7.25,0,0,1-2-.26,5.06,5.06,0,0,1-1.46-.66,3.56,3.56,0,0,1-1-.93,4.81,4.81,0,0,1-.56-1,5.16,5.16,0,0,1-.27-1,6.57,6.57,0,0,1-.06-.81,4.09,4.09,0,0,1,.49-2,5.33,5.33,0,0,1,1.31-1.57,6,6,0,0,1,1.86-1A6.29,6.29,0,0,1,91.4,220.35Z"
            fill="#fff"
          />
          <path
            d="M97.79,216a4.55,4.55,0,0,1,.9.08,1.29,1.29,0,0,1,.61.29,1.26,1.26,0,0,1,.34.6,3.84,3.84,0,0,1,.11,1,2.48,2.48,0,0,1-.09.68,1.41,1.41,0,0,1-.29.54,1.35,1.35,0,0,1-.6.35,3.4,3.4,0,0,1-1,.12,4.44,4.44,0,0,1-.89-.08,1.14,1.14,0,0,1-.89-.88,3.61,3.61,0,0,1-.1-.9,1.9,1.9,0,0,1,.43-1.35A2,2,0,0,1,97.79,216Zm-1.55,5.73a2.81,2.81,0,0,1,.11-.73.52.52,0,0,1,.47-.35,4.89,4.89,0,0,1,.73-.11l.81,0h.32l.31,0c.19,0,.3.07.35.17a1.8,1.8,0,0,1,.06.59c0,1.36,0,2.62,0,3.81s-.1,2.4-.18,3.67c0,.19,0,.35-.05.48a.62.62,0,0,1-.13.32.64.64,0,0,1-.3.18,1.9,1.9,0,0,1-.55.06,8.94,8.94,0,0,1-1-.06,1,1,0,0,1-.75-.29,1.54,1.54,0,0,1-.2-.71c0-.46,0-.91-.06-1.36s0-.89,0-1.34c0-.72,0-1.43,0-2.14S96.19,222.52,96.24,221.77Z"
            fill="#fff"
          />
          <path
            d="M109.84,225.35a10.68,10.68,0,0,1-1.16.33c-.46.1-.94.19-1.45.26s-1,.14-1.6.2-1.07.1-1.58.12a2.65,2.65,0,0,0,1,.7,3.15,3.15,0,0,0,1.26.25,6,6,0,0,0,1.16-.14,5.55,5.55,0,0,0,1.21-.41,1.21,1.21,0,0,1,.4-.13.25.25,0,0,1,.22.1,1.35,1.35,0,0,1,.16.32,3.17,3.17,0,0,1,.12.41l.09.42a.81.81,0,0,1,0,.2v.18a.88.88,0,0,1-.3.65,4.11,4.11,0,0,1-1.6.88,7.67,7.67,0,0,1-2.33.33,4.8,4.8,0,0,1-3.31-1.31,5.06,5.06,0,0,1-1-1.5,4.72,4.72,0,0,1-.4-2,4.82,4.82,0,0,1,.41-2,4.95,4.95,0,0,1,4.54-2.94,4.75,4.75,0,0,1,2.21.47,4.43,4.43,0,0,1,1.44,1.16,4.53,4.53,0,0,1,.78,1.42,4.17,4.17,0,0,1,.24,1.25.87.87,0,0,1-.1.42A.64.64,0,0,1,109.84,225.35Zm-4.14-2.41a2.15,2.15,0,0,0-1.23.4,2,2,0,0,0-.78,1c.57,0,1.17-.06,1.8-.12a11.3,11.3,0,0,0,1.75-.26,1.42,1.42,0,0,0-.66-.79A1.85,1.85,0,0,0,105.7,222.94Z"
            fill="#fff"
          />
          <path
            d="M111.28,221.62a4.38,4.38,0,0,1,.08-.73.53.53,0,0,1,.45-.39,5.06,5.06,0,0,1,.53-.1l.62-.06.65-.05.55,0a.48.48,0,0,1,.38.13.64.64,0,0,1,.09.36,1.93,1.93,0,0,1,0,.24c0,.08,0,.17,0,.28a5.13,5.13,0,0,1,1.48-.74,5.09,5.09,0,0,1,2.53-.16,2.46,2.46,0,0,1,1,.36,2.15,2.15,0,0,1,.77.81,2.86,2.86,0,0,1,.31,1.45c0,.34,0,.74,0,1.2s-.05.94-.08,1.47-.07,1.07-.13,1.64-.12,1.13-.2,1.69a1.93,1.93,0,0,1-.18.59c-.1.19-.31.28-.64.28s-.44,0-.75-.05a8.08,8.08,0,0,1-.88-.14.75.75,0,0,1-.6-.84c0-.14,0-.31,0-.52s0-.49.08-.84.06-.8.08-1.33,0-1.19,0-2a1.29,1.29,0,0,0-.18-.73.59.59,0,0,0-.54-.28,3.11,3.11,0,0,0-1,.18,4.29,4.29,0,0,0-1.08.56q0,1.23.06,2.43c0,.8.11,1.59.18,2.39a.82.82,0,0,1,0,.21,1.15,1.15,0,0,1,0,.19.59.59,0,0,1-.2.49,1.52,1.52,0,0,1-.8.21l-.3,0h-.65l-.29,0a1,1,0,0,1-.76-.27,1.39,1.39,0,0,1-.24-.68c-.1-1-.18-1.94-.25-2.93s-.09-2-.09-3v-.68C111.26,222.07,111.26,221.84,111.28,221.62Z"
            fill="#fff"
          />
          <path
            d="M127.36,220.35c.29,0,.59,0,.91.05a4,4,0,0,1,1,.25,1.45,1.45,0,0,1,.62.4,1.41,1.41,0,0,1,.25.76c0,.2,0,.39.06.58s0,.36,0,.54a7.2,7.2,0,0,1-.12,1.32,1,1,0,0,1-.22.54.73.73,0,0,1-.54.15,6,6,0,0,1-1-.08,1,1,0,0,1-.86-.89c0-.18,0-.36-.05-.56s0-.39,0-.58a3.26,3.26,0,0,0-1,.23,3,3,0,0,0-.8.48,2.23,2.23,0,0,0-.54.69,1.87,1.87,0,0,0-.2.88,2.4,2.4,0,0,0,.15.84,2,2,0,0,0,.43.71,2.2,2.2,0,0,0,.7.49,2.25,2.25,0,0,0,.92.18,2.78,2.78,0,0,0,.54-.06c.19,0,.39-.09.58-.15l.53-.2.41-.2.35-.16a.6.6,0,0,1,.26-.07c.17,0,.32.12.46.36s.15.29.22.44a4,4,0,0,1,.21.47l.1.31a1.51,1.51,0,0,1,0,.26.8.8,0,0,1-.31.55,3.49,3.49,0,0,1-.68.45,6.86,6.86,0,0,1-.87.35,6.64,6.64,0,0,1-1,.23,5.72,5.72,0,0,1-1,.09,7.25,7.25,0,0,1-2.05-.26,5.06,5.06,0,0,1-1.46-.66,3.56,3.56,0,0,1-1-.93,4.81,4.81,0,0,1-.56-1,5.16,5.16,0,0,1-.27-1,6.57,6.57,0,0,1-.06-.81,4.09,4.09,0,0,1,.49-2,5.19,5.19,0,0,1,1.31-1.57,6,6,0,0,1,1.86-1A6.29,6.29,0,0,1,127.36,220.35Z"
            fill="#fff"
          />
          <path
            d="M140.65,225.35a9.83,9.83,0,0,1-1.15.33c-.46.1-.94.19-1.45.26s-1.05.14-1.6.2-1.07.1-1.58.12a2.65,2.65,0,0,0,1,.7,3.15,3.15,0,0,0,1.26.25,5.86,5.86,0,0,0,1.15-.14,5.46,5.46,0,0,0,1.22-.41,1.21,1.21,0,0,1,.4-.13.25.25,0,0,1,.22.1,1.87,1.87,0,0,1,.16.32,3.17,3.17,0,0,1,.12.41c0,.14.06.28.08.42a.54.54,0,0,1,0,.2v.18a.88.88,0,0,1-.3.65,4.11,4.11,0,0,1-1.6.88,7.67,7.67,0,0,1-2.33.33,4.8,4.8,0,0,1-3.31-1.31,5.06,5.06,0,0,1-1.05-1.5,4.72,4.72,0,0,1-.4-2,4.82,4.82,0,0,1,.41-2,4.95,4.95,0,0,1,4.54-2.94,4.75,4.75,0,0,1,2.21.47,4.43,4.43,0,0,1,1.44,1.16,4.53,4.53,0,0,1,.78,1.42,4.17,4.17,0,0,1,.24,1.25.87.87,0,0,1-.1.42A.63.63,0,0,1,140.65,225.35Zm-4.13-2.41a2.15,2.15,0,0,0-1.23.4,2,2,0,0,0-.78,1c.57,0,1.17-.06,1.8-.12a11.12,11.12,0,0,0,1.75-.26,1.42,1.42,0,0,0-.66-.79A1.85,1.85,0,0,0,136.52,222.94Z"
            fill="#fff"
          />
        </g>
      </g>
      <Checkmarks
        visited={visited}
        process={process}
        position={{ x: 20, y: 160 }}
        gradientIdChunk="science"
      />
    </g>
  );
};

export default Science;
